<template>
  <div class="company-details order-mng mar-bt-0">
    <div>
      <div>
        <div>
          <form>
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <el-collapse v-model="activeNames">
              <template v-for="(order, orderIdx) in model.ordering_management">
                <template v-if="deliveryMethodLabels[getObjectByElemKeyValue('key', order.type, deliveryMethodLabels)]">
                  <div class="pull-right disable-chck" @click="updateTabs(model.id + order.type, order.enabled)">
                    <p-checkbox
                    value="true"
                    v-model="order.enabled"
                    key="order.type"
                    :label="order.label"
                    @click="updateTabs(model.id + order.type)" 
                      >{{$t('settingsOrdering.enabled')}}</p-checkbox>
                  </div>
                  <el-collapse-item :title="deliveryMethodLabels[getObjectByElemKeyValue('key', order.type, deliveryMethodLabels)]['label']" :name="model.id + order.type" class="text-left" :class="order.enabled ? '' : 'disabled'">
                    <form>
                      <template v-if="order.type == 'eat_location'">
                        <div class="form-group" >
                        <p-checkbox
                          value="true"
                          v-model="order.reservation_available_in_app"
                          key="order.reservation_available_in_app"
                          :label="order.reservation_available_in_app"
                        >{{$t('settingsOrdering.reservation_available_in_app')}}</p-checkbox>
                        </div>

                        <div class="form-group">
                          <hr>
                        </div>

                        <div class="reservations-widget-embed">
                          <div class="rw-config">
                            <h6>{{ $t('settingsOrdering.reservationWidgetTitle') }}</h6>
                            <p class="rw-hint">{{ $t('settingsOrdering.reservationWidgetHint') }}</p>

                            <div class="rw-auto-ids">
                              <div>
                                <span>Company ID</span>
                                <code>{{ reservationWidgetCompanyId }}</code>
                              </div>
                              <div>
                                <span>Method ID</span>
                                <code>{{ order.id || '-' }}</code>
                              </div>
                              <div>
                                <span>Location token</span>
                                <code>{{ model.token || '-' }}</code>
                              </div>
                            </div>

                            <div class="form-group">
                              <label>{{ $t('settingsOrdering.reservationWidgetPosition') }}</label>
                              <div class="rw-position-btns">
                                <button
                                  v-for="pos in reservationWidgetPositions"
                                  :key="pos.id"
                                  type="button"
                                  class="rw-pos-choice"
                                  :class="{ active: reservationWidget.position === pos.id }"
                                  @click.prevent="reservationWidget.position = pos.id"
                                >{{ pos.label }}</button>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>{{ $t('settingsOrdering.reservationWidgetLanguage') }}</label>
                                  <select class="form-control" v-model="reservationWidget.language">
                                    <option v-for="lang in reservationWidgetLanguages" :key="lang.id" :value="lang.id">{{ lang.label }}</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>{{ $t('settingsOrdering.reservationWidgetHoursToStay') }}</label>
                                  <input type="number" min="1" class="form-control" v-model.number="reservationWidget.hoursToStay">
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>{{ $t('settingsOrdering.reservationWidgetDefaultPersons') }}</label>
                                  <input type="number" min="1" class="form-control" v-model.number="reservationWidget.defaultPersons">
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>{{ $t('settingsOrdering.reservationWidgetCountryPrefix') }}</label>
                                  <input type="text" class="form-control" v-model="reservationWidget.countryCodePrefix">
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>{{ $t('settingsOrdering.reservationWidgetTableZone') }}</label>
                                  <select class="form-control" v-model="reservationWidget.tableZoneId">
                                    <option :value="0">{{ $t('general.all') }}</option>
                                    <option v-for="zone in tableZones" :key="zone.id" :value="zone.id">{{ zone.name }}</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>{{ $t('settingsOrdering.reservationWidgetRestaurantName') }}</label>
                                  <input type="text" class="form-control" v-model="reservationWidget.restaurantName" @input="reservationWidget.restaurantNameCustomized = true">
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="rw-preview-col">
                            <label>{{ $t('settingsOrdering.reservationWidgetPreview') }}</label>
                            <div class="rw-site-preview" :class="'pos-' + reservationWidget.position">
                              <div class="rw-browser-bar">
                                <span></span><span></span><span></span>
                              </div>
                              <div class="rw-fab">
                                <span class="rw-fab-icon">
                                  <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
                                    <rect x="4" y="6" width="16" height="14" rx="2" fill="none" stroke="#2c2a72" stroke-width="1.8"/>
                                    <path d="M8 6V4M16 6V4M4 10h16" fill="none" stroke="#2c2a72" stroke-width="1.8" stroke-linecap="round"/>
                                    <rect x="8" y="13" width="3" height="3" rx="0.6" fill="#2c2a72"/>
                                  </svg>
                                </span>
                                <span class="rw-fab-text">
                                  <strong>{{ reservationWidgetButtonLabel }}</strong>
                                  <span class="rw-online"><span class="rw-online-dot"></span>ONLINE</span>
                                </span>
                                <span class="rw-fab-arrow">
                                  <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                                    <path d="M9 6l6 6-6 6" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                </span>
                              </div>
                            </div>

                            <label>{{ $t('settingsOrdering.reservationWidgetScript') }}</label>
                            <textarea class="form-control rw-script" readonly rows="12" :value="getReservationWidgetScript(order)"></textarea>
                            <button type="button" class="btn btn-success rw-copy-btn" @click.prevent="copyReservationWidgetScript(order)">
                              {{ reservationWidget.copied ? $t('settingsOrdering.reservationWidgetCopied') : $t('settingsOrdering.reservationWidgetCopy') }}
                            </button>
                          </div>
                        </div>

                        <template>
                          <div class="form-group">
                            <label>{{$t('settingCompany.closeOrders', {deliveryMethod: order.label})}}</label>
                            <select v-model="order.closeOrder"
                                  class="form-control sml"
                                  @input="handleClosingHour(orderIdx, $event)">
                              <option v-for="option in closeOrderOptions"
                                      :value="option.id"
                                      >{{option.label}}</option>
                            </select>
                            <template v-if="order.closeOrder">
                              <el-time-select
                                placeholder="Select hour"
                                v-model="order.auto_close_orders_at_hour"
                                :picker-options="picker_options_orders_starts_from">
                              </el-time-select>
                            </template>
                            <template v-else>
                              <input
                                class="form-control sml"
                                :name="model.id + order.type + 'auto_close_orders_after_hour'"
                                type="number"
                                v-model="order.auto_close_orders_after_hour"
                                min="0"
                                max="12"
                                placeholder="3"
                                v-validate="modelValidate.auto_close_orders_after_hour">
                              <label>{{$t('settingsOrdering.hours')}}</label>
                              <label class="text-danger" v-show="errors.has(model.id + order.type + 'auto_close_orders_after_hour')">
                                {{$t('settingsOrdering.closeOrderAfterHours')}}
                              </label>
                            </template>
                          </div>
                        </template>

                        <template>
                          <div class="form-group">
                            <div class="checkbox mar-bt-20">
                              <input type="checkbox" 
                                      v-model="isAutoChangeEnabled[orderIdx]"
                                      @change="isAutoChangeEnabledChange(orderIdx)">
                              <label>{{$t('settingCompany.autoChangeStatus', {deliveryMethod: order.label})}}</label>
                            </div>
                            <template v-if="isAutoChangeEnabled[orderIdx]">
                              <select v-model="order.status_from_auto_change"
                                    class="form-control sml">
                                <option v-for="option1 in statusesAutoChange"
                                        :value="option1.name"
                                        >{{option1.name}}</option>
                              </select>
                              ->
                              <select v-model="order.status_to_auto_change"
                                    class="form-control sml">
                                <template v-for="option in statusesAutoChange">
                                  <template v-if="order.status_from_auto_change == option.name">
                                    <option v-for="option2 in option.values"
                                        :value="option2"
                                        >{{option2}}</option>
                                  </template>
                                </template>
                              </select>
                              <input
                                  class="form-control sml"
                                  :name="model.id + order.type + 'auto_change_status_after_min'"
                                  type="number"
                                  v-model="order.auto_change_status_after_min"
                                  min="0"
                                  max="360"
                                  placeholder="1"
                                  v-validate="modelValidate.auto_change_status_after_min">
                                <label>{{$t('settingsOrdering.minutes')}}</label>
                                <label class="text-danger" v-show="errors.has(model.id + order.type + 'auto_change_status_after_min')">
                                  {{$t('settingsOrdering.errorAutoChangeStatusAfterMin')}}
                                </label>
                            </template>
                          </div>
                        </template>

                        <template v-if="order.reservation_available_in_app">
                          <div class="form-group">
                              <label>Numărul minim de persoane pentru o rezervare</label>  
                              <input type="number"
                                      min="0"
                                      :name="model.id + order.type + 'min_reservation'" class="form-control sml" 
                                      v-model="order.min_reservation"
                                      :disabled="!order.enabled"
                                      placeholder=""
                                      v-validate="modelValidate.required">
                          </div>
                          <div class="form-group">
                              <label>Numărul maxim de persoane pentru o rezervare</label>  
                              <input type="number"
                                      min="0"
                                      :name="model.id + order.type + 'max_reservation'" class="form-control sml" 
                                      v-model="order.max_reservation"
                                      :disabled="!order.enabled"
                                      placeholder=""
                                      v-validate="modelValidate.required">
                          </div>
                          <div class="form-group">
                              <label>{{$t('settingsOrdering.max_number_seats')}}</label>
                              <input
                                type="number"
                                min="0"
                                :name="model.id + order.type + 'max_number_seats'"
                                class="form-control sml"
                                v-model="order.max_number_seats"
                                :disabled="!order.enabled"
                                placeholder=""
                              >
                          </div>
                          <div class="form-group">
                              <label>{{$t('settingsOrdering.min_between_reservations')}}</label>
                              <input type="number"
                                      min="0"
                                      :name="model.id + order.type + 'min_between_reservations'" 
                                      class="form-control sml"
                                      placeholder=""
                                      :disabled="!order.enabled"
                                      v-validate="modelValidate.required"
                                      v-model="order.min_between_reservations"
                                      >
                          </div>                          
                          <div class="form-group">
                            <label>{{$t('settingsOrdering.min_interval_reservations')}}</label>
                            <input type="number"
                                    min="0"
                                    :name="model.id + order.type + 'min_interval_reservations'" 
                                    class="form-control sml"
                                    placeholder=""
                                    :disabled="!order.enabled"
                                    v-validate="modelValidate.required"
                                    v-model="order.min_standard_reservations"
                                    >
                          </div>
                          <div class="form-group">
                            <div class="row">
                              <div class="col-md-6">
                                <table class="table no-margin">
                                  <thead>
                                    <tr>
                                        <th style="min-width: 200px">{{$t('settingsOrdering.min_standard_reservations')}}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(resInt, resInt_idx) in order.reservations_intervals">
                                        <td>
                                          <div class="row">
                                              <div class="col-md-12">
                                                <input type="number" min="0" max="8" class="form-control" v-model="order.reservations_intervals[resInt_idx]">
                                              </div>
                                          </div>
                                        </td>
                                        <td><button class="btn btn-simple btn-icon " @click.prevent="deleteReservationsIntervalsValue(orderIdx, resInt_idx)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button></td>
                                    </tr>
                                  </tbody>
                                  <button class="btn add mar-to-15 "
                                          @click.prevent="addMoreReservationsIntervals(orderIdx)"
                                          :title="$t('general.add')  + ' moreIntervals'" >
                                      <img src="/static/img/icons/add.png">
                                      {{$t('general.add')}}
                                  </button>
                                </table>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label :for="'swAlwaysOpen_'+order.id" style="margin-right: 10px;">{{$t('settingsOrdering.isAlwaysOpen')}}</label>
                            <p-switch :name="'swAlwaysOpen_'+order.id" v-model="order.is_always_open" type="success"></p-switch>
                          </div>
                          <div class="form-group" v-if="order.is_always_open">
                            <label for="" style="margin-bottom: 12px;">
                              {{$t('settingsOrdering.isAlwaysOpenPreorderHours')}}
                              <input type="number"
                                min="0"
                                class="form-control"
                                :name="model.id + order.type +'is_always_open_preorder_hours'"
                                v-model="order.is_always_open_preorder_hours"
                                :disabled="!order.enabled">
                            </label>
                          </div>
                          <div class="form-group">
                            <label for="" style="margin-bottom: 12px; margin-right: 10px;">
                              {{$t('settingsOrdering.offset')}}
                              <input type="number"
                                min="0"
                                class="form-control"
                                :name="model.id + order.type +'offset'"
                                v-validate="modelValidate.offset"
                                v-model="order.offset"
                                :disabled="!order.enabled || order.is_always_open">
                            </label>
                            <label for="" style="margin-bottom: 12px;">
                              {{$t('settingsOrdering.period')}}
                              <input type="number"
                                min="1"
                                class="form-control" 
                                :name="model.id + order.type +'period'"
                                v-validate="modelValidate.period"
                                v-model="order.period"
                                :disabled="!order.enabled || order.is_always_open">
                            </label>
                          </div>
                          <div class="form-group">
                            <hr>
                          </div>
                          <div class="form-group">
                              <label>{{$t('settingsOrdering.available_days')}}</label>
                              <div class="row" v-for="(day, dayIdx) in order.available_days" style="display: flex; align-items: flex-start; margin-bottom: 20px;">
                              <div class="col-md-6">
                                  <div class="row">
                                  <div class="col-md-3 padd in-inline-160">
                                      <div class="checkbox">
                                      <input v-if="dayIdx == 0" type="checkbox" 
                                              :value="day.day"
                                              v-model="day.open"
                                              :name="model.id + order.type + 'days'"
                                              :id="model.id + order.type + day.day"
                                              v-validate="{required: true}"
                                              :disabled="!order.enabled || order.is_always_open"
                                              >
                                      <input v-else  type="checkbox" 
                                              :value="day.day"
                                              v-model="day.open"
                                              :name="model.id + order.type + 'days'"
                                              :id="model.id + order.type + day.day"
                                              :disabled="!order.enabled || order.is_always_open"
                                              >
                                      <label :for="model.id + order.type + day.day">{{$t('days.' + day.day) | capitalize}}</label>
                                      </div>
                                  </div>
                                  <div class="col-md-9 padd">
                                      from
                                      <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                      placeholder="Select time"
                                                      :value="day.open_from"
                                                      v-model="day.open_from"
                                                      v-validate="modelValidate.available_days"
                                                      :picker-options="pickerOptions">
                                      </el-time-select>
                                      to
                                      <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                      placeholder="Select time"
                                                      :value="day.open_to"
                                                      v-model="day.open_to"
                                                      v-validate="modelValidate.available_days"
                                                      :picker-options="pickerOptions">
                                      </el-time-select>
                                  </div>
                                  </div>
                                  <div class="row intervals" v-if="day.intervals">
                                  <template v-for="(interval, intervalKey) in day.intervals">
                                      <div class="col-md-3 padd in-inline-160"></div>
                                      <div class="col-md-9 padd">
                                      from
                                      <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                      placeholder="Select time"
                                                      :value="interval.open_from"
                                                      v-model="interval.open_from"
                                                      v-validate="modelValidate.available_days"
                                                      :picker-options="pickerOptions">
                                      </el-time-select>
                                      to
                                      <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                      placeholder="Select time"
                                                      :value="interval.open_to"
                                                      v-model="interval.open_to"
                                                      v-validate="modelValidate.available_days"
                                                      :picker-options="pickerOptions">
                                      </el-time-select>
                                      <button class="btn btn-simple btn-icon " :disabled="order.is_always_open" @click.prevent="deleteIntervals(intervalKey, dayIdx, orderIdx)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button>
                                  </div>
                                  </template>
                                  </div>
                              </div>
                              <div class="col-md-2">
                                  <button class="btn add mar-to-15 "
                                          @click.prevent="addMoreIntervals(dayIdx, orderIdx)"
                                          :disabled="order.is_always_open"
                                          :title="$t('general.add')  + ' moreIntervals'" >
                                      <img src="/static/img/icons/add.png">
                                      {{$t('general.add')}}
                                  </button>
                              </div>
                              </div>
                          </div>
                          <div class="form-group">
                            <hr>
                          </div>
                          <div class="form-group" >
                            <p-checkbox
                              value="true"
                              v-model="order.reservation_pay_per_person"
                              key="order.reservation_pay_per_person"
                              :label="order.reservation_pay_per_person"
                            >{{$t('settingsOrdering.reservation_pay_per_person')}}</p-checkbox>
                          </div>
                          <div class="form-group">
                            <div class="form-group">
                              <div class="card" style="box-shadow: none; border: 1px solid #dcdfe6;">
                                <div class="card-content">
                                  <div class="prod-tabs" direction="horizontal" type="tabs">
                                    <div class="col-md-12 display-flex align-items-center justify-content-space-between">
                                      <h6>{{$t('settingsOrdering.reservationTaxesTitle')}}</h6>
                                      <button
                                        class="btn add mar-to-15"
                                        @click.prevent="addReservationTaxesInfo(orderIdx)"
                                        :title="$t('general.add')  + ' ' + $t('catalogProdOpt.single')" >
                                          <img src="/static/img/icons/add.png">
                                          {{$t('general.add')}}
                                      </button>
                                    </div>
                                    <div class="col-md-12 pad-lf-0 pad-rg-0">
                                      <hr class="sm">
                                    </div>
                                    <div :title="$t('catalogProdOpt.plural')" class="text-left">
                                      <div class="row">
                                        <div class="col-md-12" >
                                        <p v-if="order.reservation_taxes && order.reservation_taxes.length == 0" class="">{{$t('settingsOrdering.reservationTaxesTitleEmpty')}}</p>
                                        <el-collapse ref="elColl" v-model="reservationTaxesIndex" accordion>
                                            <template v-for="(tax, idTax) in order.reservation_taxes">
                                            <div class="align" v-if="!tax.deleted_at">
                                                <el-collapse-item class="customItem" :title="tax.name === '' ? 'Name' : tax.name" :name="idTax">
                                                <div class="clearfix"><hr class="no-margin mar-bt-15" /></div>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                    <span>ID: {{tax.id}}</span>
                                                    </div>
                                                    <div class="col-md-12">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>{{$t('catalogProd.name')}}</label>
                                                            <input type="text"
                                                                    name="name"
                                                                    :placeholder="$t('catalogProd.name')"
                                                                    v-validate="'required'"
                                                                    v-model="tax.name"
                                                                    class="form-control">
                                                            <small class="text-danger" v-if="errors.has('name')">
                                                            {{ getError('name') }}
                                                            </small>
                                                        </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>{{$t('settingsOrdering.chooseZone')}}</label>
                                                            <select class="form-control" v-model="tax.table_zone_id">
                                                            <option :value="0">{{$t('general.all')}}</option>
                                                            <template v-for="zone in tableZones">
                                                                <option :value="zone.id">{{zone.name}}</option>
                                                            </template>
                                                            </select>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>{{$t('marketingOffers.startEndDate')}}</label><br>
                                                            <el-date-picker type="date"
                                                                            v-model="tax.date_from"
                                                                            value-format="yyyy-MM-dd"
                                                                            format="dd/MM/yyyy"
                                                                            :picker-options="{
                                                                            disabledDate (time) {
                                                                                if ((time.getTime() + 86401 * 1000) < Date.now()) {
                                                                                return true
                                                                                } else {
                                                                                return false
                                                                                }
                                                                            }
                                                                            }">
                                                            </el-date-picker>
                                                            <el-date-picker type="date"
                                                                            v-model="tax.date_to"
                                                                            value-format="yyyy-MM-dd"
                                                                            format="dd/MM/yyyy"
                                                                            :picker-options="pickerOptionsTaxTo">
                                                            </el-date-picker>
                                                        </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>{{$t('catalogProd.price')}}</label>
                                                            <input type="number"
                                                                    min="0"
                                                                    name="name"
                                                                    :placeholder="$t('catalogProd.price')"
                                                                    v-validate="'required'"
                                                                    v-model="tax.price"
                                                                    class="form-control">
                                                            <div class="mar-to-15" v-if="Number(tax.price) > 0">
                                                              <p-checkbox
                                                                value="true"
                                                                v-model="tax.is_advance_consumption"
                                                                :key="'adv_' + idTax"
                                                                :label="tax.is_advance_consumption"
                                                              >{{$t('settingsOrdering.reservationTaxAdvanceConsumption')}}</p-checkbox>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </el-collapse-item>
                                                <div class="closeBtn">
                                                  <button class="btn btn-danger pull-left btn-icon mar-15" :title="$t('general.delete')" @click.prevent="deleteReservationTaxesInfo(orderIdx, idTax)">
                                                    <i class="ti-close"></i>
                                                  </button>
                                                </div>
                                            </div>
                                            </template>
                                        </el-collapse>
                                        </div>
                                        <div class="col-md-12 pad-to-15 pad-bt-10">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div class="form-group">
                            <label>{{$t('settingsOrdering.paymentOptions')}}</label>
                            <div class="checkbox mar-bt-20" v-for="(opt, idx) in paymentOptions">
                              <input v-if="idx == 0" type="checkbox"
                                :value="opt.payment_id"
                                :name="model.id + order.type + 'payment'"
                                :id="model.id + order.type + opt.payment_id"
                                v-validate="{required: true}"
                                v-model="order.payment_options[opt.payment_id]" 
                                :disabled="!order.enabled">
                              <input v-else  type="checkbox"
                                :value="opt.payment_id"
                                :name="model.id + order.type + 'payment'"
                                :id="model.id + order.type + opt.payment_id"
                                v-model="order.payment_options[opt.payment_id]" 
                                :disabled="!order.enabled">
                              <label :for="model.id + order.type + opt.payment_id">{{opt.name}}</label>
                            </div>
                            <label class="text-danger" v-show="errors.has(model.id + order.type + 'payment')">
                              {{$t('settingsOrdering.paymentOptionsErr')}}
                            </label>
                          </div>
                          <div class="form-group" v-if="order.type != 'delivery'">
                            <label>{{$t('settingsOrdering.minimumOrderValue')}}</label>
                            <input 
                              type="number"
                              min="0"
                              :name="model.id + order.type + 'minimum_order_value'" 
                              class="form-control sml"
                              placeholder=""
                              v-validate="{required: true, min_value: 0}"
                              :disabled="!order.enabled"
                              v-model="order.minimum_order_value"
                              ><b>{{currency}}</b>
                          </div>
                          <div class="form-group" >
                            <label>{{$t('settingsOrdering.waitingTime')}}</label>  
                            <input 
                              type="number"
                              min="0"
                              :name="model.id + order.type + 'default_waiting_time'" class="form-control sml" 
                              v-model="order.default_waiting_time"
                              :disabled="!order.enabled"
                              placeholder=""
                              v-validate="modelValidate.required">
                            <label>{{$t('settingsOrdering.minutes')}}</label>
                          </div>
                          <div class="form-group" v-if="order.type == 'eat_location'">
                            <label>Minim rezervari</label>  
                            <input 
                              type="number"
                              min="0"
                              :name="model.id + order.type + 'min_reservation'" class="form-control sml" 
                              v-model="order.min_reservation"
                              :disabled="!order.enabled"
                              placeholder=""
                              v-validate="modelValidate.required">
                          </div>
                          <div class="form-group" v-if="order.type == 'eat_location'">
                            <label>Maxim rezervari</label>  
                            <input
                              type="number"
                              min="0"
                              :name="model.id + order.type + 'max_reservation'" class="form-control sml" 
                              v-model="order.max_reservation"
                              :disabled="!order.enabled"
                              placeholder=""
                              v-validate="modelValidate.required">
                          </div>
                          <div class="form-group">
                            <template v-if="order.type != 'self_ordering' && !order.use_multiple_delivery_preferences">
                              <div class="form-group">
                                <label :for="'swPreorders_'+order.id" style="margin-right: 10px;">{{$t('settingsOrdering.noPreorders')}}</label>
                                <p-switch :name="'swPreorders_'+order.id" v-model="order.no_preorders" type="success"></p-switch>
                                <span v-if="order.offset > 0 || order.period > 1">{{$t('settingsOrdering.offnoPreorders')}}</span>
                              </div>
                              <div class="form-group">
                                <label :for="'swAlwaysOpen_'+order.id" style="margin-right: 10px;">{{$t('settingsOrdering.isAlwaysOpen')}}</label>
                                <p-switch :name="'swAlwaysOpen_'+order.id" v-model="order.is_always_open" type="success"></p-switch>
                              </div>
                              <div class="form-group" v-if="order.is_always_open">
                                <label for="" style="margin-bottom: 12px;">
                                  {{$t('settingsOrdering.isAlwaysOpenPreorderHours')}}
                                  <input type="number"
                                    min="0"
                                    class="form-control"
                                    :name="model.id + order.type +'is_always_open_preorder_hours'"
                                    v-model="order.is_always_open_preorder_hours"
                                    :disabled="!order.enabled">
                                </label>
                              </div>
                              <label>{{$t('settingsOrdering.availableDays')}}</label>
                              <br/>
                              <label class="text-danger" v-show="errors.has(model.id + order.type + 'days')">
                                {{$t('settingsOrdering.availableDaysErr')}}
                              </label>
                              <div class="changeDeliveryDisponibility">
                                <div class="">
                                    <!-- v-if="order.type != 'eat_location' || (dusg.id != 2 && order.type === 'eat_location')" -->
                                  <p-radio v-for="(dusg, dusgId) in delivery_hour_usage"
                                    :key="dusgId"
                                    v-model="order.delivery_hour_usage"
                                    @input="changeDeliveryHourUsage(order)"
                                    :label="dusgId"
                                    :inline="true">{{$t('settingsOrdering')[dusg.name] }}
                                  </p-radio>
                                </div>
                                <hr/>
                              </div>
                              </template>
                              <template v-if="!order.deactivate_delivery_hour_usage">
                              <template v-if="order.type != 'self_ordering'">
                                <label for="" style="margin-bottom: 12px; margin-right: 10px;">
                                  {{$t('settingsOrdering.offset')}}
                                  <input type="number"
                                    min="0"
                                    class="form-control"
                                    :name="model.id + order.type +'offset'"
                                    v-validate="modelValidate.offset"
                                    v-model="order.offset"
                                    :disabled="order.is_always_open">
                                </label>
                                <label for="" style="margin-bottom: 12px;">
                                  {{$t('settingsOrdering.period')}}
                                  <input type="number"
                                    min="1"
                                    class="form-control" 
                                    :name="model.id + order.type +'period'"
                                    v-validate="modelValidate.period"
                                    v-model="order.period"
                                    :disabled="order.is_always_open">
                                </label>
                              </template>
                              <div class="row" v-for="(day, dayIdx) in order.available_days" style="display: flex; align-items: flex-start; margin-bottom: 20px;">
                                <div class="col-md-6">
                                <div class="row">
                                    <div class="col-md-3 padd in-inline-160">
                                    <div class="checkbox">
                                        <input v-if="dayIdx == 0" type="checkbox" 
                                                :value="day.day"
                                                v-model="day.open"
                                                :name="model.id + order.type + 'days'"
                                                :id="model.id + order.type + day.day"
                                                v-validate="{required: true}"
                                                :disabled="!order.enabled || order.is_always_open"
                                                >
                                        <input v-else  type="checkbox" 
                                                :value="day.day"
                                                v-model="day.open"
                                                :name="model.id + order.type + 'days'"
                                                :id="model.id + order.type + day.day"
                                                :disabled="!order.enabled || order.is_always_open"
                                                >
                                        <label :for="model.id + order.type + day.day">{{$t('days.' + day.day) | capitalize}}</label>
                                    </div>
                                    </div>
                                    <div class="col-md-9 padd">
                                    from
                                    <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                    placeholder="Select time"
                                                    :value="day.open_from"
                                                    v-model="day.open_from"
                                                    v-validate="modelValidate.available_days"
                                                    :picker-options="pickerOptions">
                                    </el-time-select>
                                    to
                                    <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                    placeholder="Select time"
                                                    :value="day.open_to"
                                                    v-model="day.open_to"
                                                    v-validate="modelValidate.available_days"
                                                    :picker-options="pickerOptions">
                                    </el-time-select>
                                    </div>
                                </div>
                                <div class="row intervals" v-if="day.intervals">
                                    <template v-for="(interval, intervalKey) in day.intervals">
                                    <div class="col-md-3 padd in-inline-160"></div>
                                    <div class="col-md-9 padd">
                                    from
                                    <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                    placeholder="Select time"
                                                    :value="interval.open_from"
                                                    v-model="interval.open_from"
                                                    v-validate="modelValidate.available_days"
                                                    :picker-options="pickerOptions">
                                    </el-time-select>
                                    to
                                    <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                    placeholder="Select time"
                                                    :value="interval.open_to"
                                                    v-model="interval.open_to"
                                                    v-validate="modelValidate.available_days"
                                                    :picker-options="pickerOptions">
                                    </el-time-select>
                                    <button class="btn btn-simple btn-icon " :disabled="order.is_always_open" @click.prevent="deleteIntervals(intervalKey, dayIdx, orderIdx)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button>
                                    </div>
                                    </template>
                                </div>
                                </div>
                                <div class="col-md-2">
                                <button
                                  class="btn add"
                                  @click.prevent="addMoreIntervals(dayIdx, orderIdx)"
                                  :disabled="order.is_always_open"
                                  :title="$t('general.add')  + ' moreIntervals'" >
                                  <img src="/static/img/icons/add.png">
                                  {{$t('general.add')}}
                                </button>
                                </div>
                              </div>
                            </template>
                          </div>
                          <div class="form-group">
                            <hr>
                          </div> 
                        </template>

                        <div class="row" v-if="order.type != 'self_ordering'">
                          <div class="col-md-12">
                              <div class="form-group">
                                  <div class="card" style="box-shadow: none; border: 1px solid #dcdfe6;">
                                      <div class="card-content">
                                          <div class="prod-tabs" direction="horizontal" type="tabs">
                                              <div class="col-md-12 display-flex align-items-center justify-content-space-between">
                                                  <h6>{{$t('settingsOrdering.infoBoxTitle')}}</h6>
                                                  <button class="btn add "
                                                          @click.prevent="addMethodInfo(orderIdx)"
                                                          :title="$t('general.add')  + ' ' + $t('catalogProdOpt.single')" >
                                                        <img src="/static/img/icons/add.png">
                                                        {{$t('general.add')}}
                                                  </button>
                                              </div>
                                              <div class="col-md-12 pad-lf-0 pad-rg-0">
                                                  <hr class="sm">
                                              </div>
                                              <div :title="$t('catalogProdOpt.plural')" class="text-left">
                                                  <div class="row">

                                                      <div class="col-md-12" >
                                                          <p v-if="!order.method_info || (order.method_info && order.method_info.length == 0)" class="">No options added yet.</p>
                                                          <el-collapse ref="elColl" v-model="methodInfoIndex" accordion>
                                                              <template v-for="(option, idxO) in order.method_info">
                                                              <div class="align">
                                                                  <el-collapse-item class="customItem" :title="option.title === '' ? 'Name' : option.title" :name="idxO">
                                                                  <div class="clearfix"><hr class="no-margin mar-bt-15" /></div>
                                                                  <div class="row">
                                                                      <div class="col-md-6">
                                                                      <div class="form-group">
                                                                          <label>{{$t('catalogProd.name')}}</label>
                                                                          <input type="text"
                                                                                  name="name"
                                                                                  :placeholder="$t('catalogProd.name')"
                                                                                  v-validate="'required'"
                                                                                  v-model="option.title"
                                                                                  class="form-control">
                                                                          <small class="text-danger" v-if="errors.has('name')">
                                                                          {{ getError('name') }}
                                                                          </small>
                                                                      </div>
                                                                      </div>
                                                                      <div class="col-md-6">
                                                                      <div class="form-group">
                                                                          <label>{{$t('settingsOrdering.infoBoxRadioCheck')}}</label>
                                                                          <select class="form-control" v-model="option.type">
                                                                          <option value="check">{{$t('settingsOrdering.infoBoxCheck')}}</option>
                                                                          <option value="radio">{{$t('settingsOrdering.infoBoxRadio')}}</option>
                                                                          </select>
                                                                      </div>
                                                                      </div>
                                                                  </div>
                                                                  <table class="table no-margin">
                                                                      <thead>
                                                                      <tr>
                                                                          <th style="min-width: 200px">{{$t('catalogProd.optVal')}}</th>
                                                                          <th>{{$t('general.delete')}}</th>
                                                                      </tr>
                                                                      </thead>
                                                                      <tbody>
                                                                      <tr v-for="(value, idx) in option.options">
                                                                          <td>
                                                                          <div class="row">
                                                                              <div class="col-md-12">
                                                                              <input type="text"
                                                                                      class="form-control"
                                                                                      v-model="value.title">
                                                                              </div>
                                                                          </div>
                                                                          </td>
                                                                          <td><button class="btn btn-simple btn-icon " @click.prevent="deleteMethodInfoOptionValue(orderIdx, idxO, idx)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button></td>
                                                                      </tr>
                                                                      </tbody>
                                                                  </table>
                                                                  <div class="pull-right">
                                                                      <button  class="btn add mar-bt-5" @click.prevent="addMethodInfoOptionValue(orderIdx, idxO)">
                                                                        <img src="/static/img/icons/add.png">
                                                                        {{$t('general.add')}}
                                                                      </button>
                                                                  </div>
                                                                  </el-collapse-item>
                                                                  <div class="closeBtn">
                                                                  <button class="btn btn-danger pull-left btn-icon mar-15" :title="$t('general.delete')" @click.prevent="deleteMethodInfo(orderIdx, idxO)"><i class="ti-close"></i></button>
                                                                  </div>
                                                              </div>
                                                              </template>
                                                          </el-collapse>
                                                      </div>
                                                      <div class="col-md-12 pad-to-15 pad-bt-10">
                                                      
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="form-group">
                          <label>{{$t('settingsOrdering.paymentOptions')}}</label>
                          <div class="checkbox mar-bt-20" v-for="(opt, idx) in paymentOptions">
                            <input v-if="idx == 0" type="checkbox"
                                    :value="opt.payment_id"
                                    :name="model.id + order.type + 'payment'"
                                    :id="model.id + order.type + opt.payment_id"
                                    v-validate="{required: true}"
                                    v-model="order.payment_options[opt.payment_id]" 
                                    :disabled="!order.enabled"
                                    >
                            <input v-else  type="checkbox"
                                    :value="opt.payment_id"
                                    :name="model.id + order.type + 'payment'"
                                    :id="model.id + order.type + opt.payment_id"
                                    v-model="order.payment_options[opt.payment_id]" 
                                    :disabled="!order.enabled"
                                    >
                            <label :for="model.id + order.type + opt.payment_id">{{opt.name}}</label>
                          </div>
                          <label class="text-danger" v-show="errors.has(model.id + order.type + 'payment')">
                            {{$t('settingsOrdering.paymentOptionsErr')}}
                          </label>
                        </div>
                        <template v-if="order.type == 'delivery'">
                          <div class="form-group">
                            <label :for="model.id + order.type + 'ump'" style="margin-right: 10px;">{{$t('deliveryPreferences.useMultiplePreferences')}}</label>
                            <p-switch :name="model.id + order.type + 'ump'" v-model="order.use_multiple_delivery_preferences" type="success"></p-switch>
                            <small class="text-muted" style="display:block;">{{$t('deliveryPreferences.useMultiplePreferencesHelp')}}</small>
                          </div>
                          <div class="form-group" v-if="order.use_multiple_delivery_preferences">
                            <label>{{$t('deliveryPreferences.selectPreferences')}}</label>
                            <p v-if="!deliveryPreferencesList.length" class="text-muted">{{$t('deliveryPreferences.noData')}}</p>
                            <template v-else>
                              <input type="text" class="form-control" v-model="preferenceSearch" :placeholder="$t('general.search')" style="margin-bottom:8px; max-width:560px;">
                              <div style="max-height:260px; overflow-y:auto; border:1px solid #e0e0e0; border-radius:4px; max-width:560px;">
                                <div v-for="pref in filteredPreferences()" :key="'pref' + pref.id"
                                     @click="togglePreference(order, pref.id)"
                                     style="display:flex; align-items:center; gap:8px; padding:8px 10px; cursor:pointer; border-bottom:1px solid #f0f0f0;"
                                     :style="{ background: isPreferenceChecked(order, pref.id) ? '#eef7ee' : 'transparent' }">
                                  <input type="checkbox" :checked="isPreferenceChecked(order, pref.id)" style="margin:0; pointer-events:none;">
                                  <span style="flex:1;">
                                    <strong v-if="pref.nume_admin">{{ pref.nume_admin }}</strong><span v-if="pref.nume_admin"> — </span>{{ pref.name }}
                                    <small class="text-muted">({{ pref.type === 2 ? $t('deliveryPreferences.typeSlot') : $t('deliveryPreferences.typeClassic') }})</small>
                                  </span>
                                </div>
                                <p v-if="!filteredPreferences().length" class="text-muted" style="padding:10px; margin:0;">{{ $t('deliveryPreferences.noData') }}</p>
                              </div>
                            </template>
                          </div>
                        </template>
                        <div class="form-group" v-if="order.type != 'delivery'">
                          <label>{{$t('settingsOrdering.minimumOrderValue')}}</label>
                          <input 
                            type="number"
                            min="0"
                            :name="model.id + order.type + 'minimum_order_value'" 
                            class="form-control sml"
                            placeholder=""
                            v-validate="{required: true, min_value: 0}"
                            :disabled="!order.enabled"
                            v-model="order.minimum_order_value"
                          >
                          <b>{{currency}}</b>
                        </div>
                        <div class="form-group" v-if="!(order.type == 'delivery' && order.use_multiple_delivery_preferences)">
                          <label>{{$t('settingsOrdering.waitingTime')}}</label>
                          <input
                            type="number"
                            min="0"
                            :name="model.id + order.type + 'default_waiting_time'" class="form-control sml"
                            v-model="order.default_waiting_time"
                            :disabled="!order.enabled"
                            placeholder=""
                            v-validate="modelValidate.required">
                          <label>{{$t('settingsOrdering.minutes')}}</label>
                        </div>
                        <div class="form-group" >
                          <label>{{$t('settingsOrdering.count_orders_starts_from_hour')}}</label>  
                          <el-time-select 
                            :disabled="!order.enabled"
                            placeholder="Select Hour"
                            :value="order.count_orders_starts_from_hour"
                            v-model="order.count_orders_starts_from_hour"
                            :picker-options="picker_options_orders_starts_from">
                          </el-time-select>
                        </div>
                        <template v-if="order.type === 'delivery' && !order.use_multiple_delivery_preferences">
                          <div class="form-group" >
                            <label>{{$t('settingsOrdering.shipping_department_id')}}</label>
                            <input type="number" min="1"
                              :name="model.id + order.type + 'shipping_department_id'" class="form-control sml" 
                              v-model.number="order.shipping_department_id"
                            >
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-12" >
                            <label>{{$t('settingsOrdering.deliveryRules')}}</label>
                            </div>
                          </div>
                          <el-radio v-for="(zoneL, zoneId) in zoneLimitations"
                            :key="model.id + order.type + zoneId"
                            v-model="order.area"
                            :change="handleChangeArea(order.area, model.id)"
                            :label="zoneId"
                            :inline="true">{{$t('settingCompany.'+ zoneL)}}
                          </el-radio>
                          <template v-if="order.area == 'radius'">
                            <delivery-tax-panel
                              v-if="taxesVersion === 2"
                              class="mar-bt-20"
                              :location-id="model.true_id || model.id"
                              :currency="currency"
                            ></delivery-tax-panel>
                            <table class="table table-rules" :key="model.id+ idx + 'rule'" v-for="(rule, idx) in order.delivery_rules">
                            <thead>
                              <tr>
                                <th width="15px"><b>{{(idx + 1)}}</b></th>
                                <th width="" style="line-height:2">
                                  {{$t('settingsOrdering.deliveryRange')}} ({{$t('settingsOrdering.deliveryRangeUnit')}})
                                  <button v-if="order.delivery_rules.length > 1"
                                    class="btn btn-danger btn-icon pull-right"
                                    @click.prevent="removeRule(model.id, idx, order.type)">
                                    <i :title="$t('general.remove')" class="ti-trash"></i> {{$t('general.remove')}}
                                  </button>
                                </th>
                              </tr>
                            </thead>
                            <tbody >
                              <tr>
                                <td>
                                </td>
                                <td>
                                  <input 
                                    type="number"
                                    min="0"
                                    :name="model.id + order.type +'delivery_range'+idx"
                                    :ref="model.id + order.type +'delivery_range'+idx"
                                    class="form-control sml"
                                    placeholder=""
                                    v-validate="{min_value: 0}"
                                    :disabled="!order.enabled"
                                    v-model="rule.delivery_range"
                                    :aria-invalid="errors.has(model.id + order.type +'delivery_range'+idx)">
                                  <table class="table table-subrules" style="">
                                    <thead>
                                      <th>{{$t('settingsOrdering.shippingNeighborhoods')}}</th>
                                      <th>{{$t('settingsOrdering.shippingCities')}}</th>
                                      <th v-if="taxesVersion !== 2" width="10%">
                                        {{$t('settingsOrdering.shippingCost')}} ({{currency}})
                                      </th>
                                      <th v-if="taxesVersion !== 2" width="10%">
                                        {{$t('catalogCateg.vat')}} <small>({{$t('catalogCateg.included')}})</small>
                                      </th>
                                      <th v-if="taxesVersion !== 2" width="10%">
                                        {{$t('settingsOrdering.posId')}}
                                      </th>
                                      <th v-if="taxesVersion !== 2" width="10%">
                                        {{$t('settingsOrdering.minimumOrderValue')}} ({{currency}})
                                      </th>
                                      <th></th>
                                    </thead>
                                      <tr :key="model.id+ idx + idxSubrule + 'subrule'" v-for="(subrule, idxSubrule) in rule.subrules">
                                        <td class="display-text-white">
                                          <el-select
                                            v-model="subrule.neighborhoods"
                                            multiple
                                            filterable
                                            allow-create
                                            default-first-option
                                            :placeholder="$t('general.add')">
                                            <el-option
                                            v-for="item in subrule.neighborhoods"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                            </el-option>
                                          </el-select>
                                        </td>
                                        <td class="display-text-white">
                                          <template>
                                            <el-select
                                              v-model="subrule.cities"
                                              multiple
                                              filterable
                                              allow-create
                                              default-first-option
                                              :placeholder="$t('general.add')">
                                              <el-option
                                              v-for="item in subrule.cities"
                                              :key="item"
                                              :label="item"
                                              :value="item">
                                              </el-option>
                                            </el-select>
                                          </template>
                                        </td>
                                        <td v-if="taxesVersion !== 2">
                                          <input type="number"
                                                  min="0"
                                                  :name="model.id + order.type +'shipping_cost'+order.type+idx+idxSubrule"
                                                  class="form-control sml" 
                                                  placeholder="" 
                                                  v-validate="{required: true, min_value: 0}"
                                                  :disabled="!order.enabled"
                                                  v-model="subrule.shipping_cost"
                                                  > 
                                        </td>
                                        <td v-if="taxesVersion !== 2">
                                          <select v-model="subrule.tax_id"
                                                  class="form-control">
                                            <option value="null">{{ $t('vat.selectVat') }}</option>
                                            <option v-for="tax in vatOptions"
                                                v-if="model.id == tax.location_token"
                                                :value="tax.id"
                                            >{{tax.amount}}
                                            </option>
                                          </select>
                                        </td>
                                        <td v-if="taxesVersion !== 2">
                                          <input type="text"
                                                  :name="model.id + order.type +'shipping_pos_id'+order.type+idx+idxSubrule"
                                                  class="form-control sml" 
                                                  :placeholder="$t('settingsOrdering.posId')" 
                                                  :disabled="!order.enabled"
                                                  v-model="subrule.shipping_pos_id"
                                                  > 
                                        </td>
                                        <td v-if="taxesVersion !== 2">
                                          <input type="text"
                                                  :name="model.id + order.type +'shipping_pos_id'+order.type+idx+idxSubrule"
                                                  class="form-control sml" 
                                                  :placeholder="$t('settingsOrdering.minimumOrderValue')" 
                                                  v-validate="{required: true, min_value: 0}"
                                                  :disabled="!order.enabled"
                                                  v-model="subrule.min_order_value"
                                                  > 
                                        </td>
                                        <td>
                                          <button v-if="rule.subrules.length > 1"
                                            class="btn btn-simple btn-icon"
                                            @click.prevent="removeSubRule(model.id, idx, idxSubrule,order.type)">
                                            <i :title="$t('general.remove')" class="ti-close text-danger"></i>
                                          </button>
                                      </td>
                                      </tr>
                                      <tr>
                                        <td :colspan="taxesVersion === 2 ? 2 : 4"></td>
                                        <td>
                                          <button :title="$t('general.add')" class="btn add" @click.prevent="addNewSubRule(model.id, order.type, idx)">
                                            <img src="/static/img/icons/add.png">
                                            {{$t('general.add')}} 
                                          </button>
                                        </td>
                                      </tr>
                                  </table>                      
                                </td>
                              </tr>
                            </tbody>
                            </table>
                            <button :title="$t('general.add')" class="btn add mar-bt-15 " @click.prevent="addNewRule(model.id, order.type)">
                              <img src="/static/img/icons/add.png">
                              {{$t('general.add')}} 
                            </button>
                            <br/>
                          </template>
                          <template v-if="order.area == 'draw'">
                            <br>
                            <hr>
                            <div class="draw-zones-toolbar">
                              <div class="disable-chck">
                                <p-checkbox
                                value="true"
                                v-model="showTheRestOfTheZones"
                                key="showTheRestOfTheZones"
                                  >{{$t('settingsOrdering.showTheRestOfTheZones')}}</p-checkbox>
                              </div>
                              <button
                                class="btn add"
                                @click.prevent="openCopyDeliveryRangesModal"
                              >
                                {{ $t('settingsOrdering.copyRangesFromLocation') }}
                              </button>
                            </div>
                            <el-collapse accordion v-model="model.mapactive">
                              <draggable v-if="deliveryRanges && deliveryRanges.length > 0 && deliveryRangesDataReady" v-model="deliveryRanges" :element="'div'">
                                <div v-for="(zone, indexZone) in deliveryRanges">
                                  <div v-if="zone" class="sortableRow" :key="indexZone">
                                    <el-collapse-item :title="zone.name == '' ? $t('settingsOrdering.newZone'):zone.name" :name="indexZone">
                                      <template slot="title">
                                        <div class="delivery-zone-header">
                                          <span>{{ zone.name == '' ? $t('settingsOrdering.newZone') : zone.name }}</span>
                                          <span v-if="zone.active === false" class="badge" style="background:#dc3545; color:#fff; padding:3px 8px; border-radius:4px; margin-left:8px;">{{ $t('zoneAvailability.inactive') }}</span>
                                          <span v-else-if="zone.schedule_enabled" class="badge" style="background:#2196f3; color:#fff; padding:3px 8px; border-radius:4px; margin-left:8px;">{{ $t('zoneAvailability.withSchedule') }}</span>
                                          <button
                                            type="button"
                                            class="btn btn-sm btn-info delivery-zone-duplicate"
                                            :title="$t('general.duplicate')"
                                            @click.stop.prevent="duplicateZone(indexZone)"
                                          >
                                            <i class="ti-files"></i> {{ $t('general.duplicate') }}
                                          </button>
                                        </div>
                                      </template>
                                      <template v-if="model.mapactive == indexZone"> 
                                        <delivery-google-maps
                                          :googleMapsapiKey=model.google_maps_api_key
                                          :cityFromParent=model.city
                                          :locationMarker="{lat: model.lat, lng: model.lng, name: model.name}"
                                          :showTheRestOfTheZones=showTheRestOfTheZones
                                          :zoneInComp=zone
                                          :deliveryRanges=deliveryRanges
                                          :indexZone=indexZone
                                          :bussLocationId=model.id
                                          :location_id=model.true_id
                                          :orderType=order.type
                                          :currency=currency
                                          :vatOptions=vatOptions
                                          :taxes-version=taxesVersion
                                          @update-zone="handleUpdateZone"
                                        ></delivery-google-maps>
                                        <zone-availability-editor
                                          :zone="zone"
                                          :showErrors="!!zone.__availability_error"
                                        ></zone-availability-editor>
                                      </template>
                                    </el-collapse-item>
                                  </div>
                                </div>
                              </draggable>
                            </el-collapse>

                            <hr>
                            <button class="btn add" @click.prevent="addNewZone(model.id, order.type)">
                              <img src="/static/img/icons/add.png">
                              {{$t('settingsOrdering.addZone')}}</button>
                            <br>
                          </template>
                          <br>
                        </template>
            
                        <div class="form-group" v-if="order.type === 'meet_half'">
                          <label>{{$t('settingsOrdering.locations')}}</label>
                          <table class="table">
                            <thead>
                              <tr>
                              <th width="23%">{{$t('settingsOrdering.street')}}</th>
                              <th width="23%">{{$t('settingsOrdering.city')}}</th>
                              <th width="23%">{{$t('settingsOrdering.country')}}</th>
                              <th width="23%">{{$t('settingsOrdering.state')}}</th>
                              <th width="8%"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(location, idx) in order.locations">
                                <td>
                                  <input type="text"
                                            class="form-control"
                                            :name="model.id + order.type +'locationstr'+order.type+idx"
                                            :disabled="!order.enabled"
                                            v-validate="modelValidate.required"
                                            v-model="location.street">
                                </td>
                                <td>
                                  <input type="text"
                                          class="form-control"
                                          :name="model.id + order.type +'locationcity'+order.type+idx"
                                          :disabled="!order.enabled"
                                          vv-validate="modelValidate.required"
                                          v-model="location.city">
                                </td>
                                <td>
                                  <select v-model="location.country"
                                          :name="model.id + order.type +'locationcountry'+order.type+idx"
                                          :disabled="!order.enabled"
                                          v-validate="modelValidate.required"
                                          class="select-primary form-control"
                                          @change="updateCountry(location)">
                                      <option v-for="country in defaults.countries"
                                              class="select-primary"
                                              :value="country.alpha2">{{country.name}}
                                      </option>
                                  </select>
                                </td>
                                <td>
                                <template v-if="showStateDrop(location)">
                                    <select v-model="location.state_id"
                                            class="select-primary form-control">
                                        <option v-for="state in getStatesOptions(location)"
                                            class="select-primary"
                                            :value="state.id">{{state.name}}
                                        </option>
                                    </select>
                                </template>
                                <template v-else>
                                    <input type="text" v-model="location.state" name="state" :placeholder="$t('settingsOrdering.state')" class="form-control" v-validate="modelValidate.required">
                                </template>
                                </td>

                                <td><button class="btn btn-simple btn-icon" @click.prevent="removeLocation(model.id, idx, order.type)"><i :title="$t('general.remove')" class="ti-close text-danger"></i></button></td> 
                              </tr>
                              <template>
                                  <tr >
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>
                                    <button :title="$t('general.add')" class="btn add" @click.prevent="addNewLocation(model.id, order.type)">
                                      <img src="/static/img/icons/add.png">
                                      {{$t('general.add')}}
                                    </button>
                                  </td>
                                  </tr>
                              </template>
                            </tbody>
                            <tfoot></tfoot>
                          </table>
                        </div>
                        <div class="form-group">
                          <template v-if="order.type == 'self_ordering'">
                            <div class="form-group">
                              <div class="checkbox mar-bt-20">
                                <input type="checkbox"
                                  :value="order.allow_sms_notifications"
                                  :name="order.id + order.type + 'allow_sms_notifications'"
                                  :id="order.id + order.type + 'allow_sms_notifications'"
                                  v-model="order.allow_sms_notifications" >
                                <label :for="order.id + order.type + 'allow_sms_notifications'">{{$t('settingsOrdering.allow_sms_notifications')}}</label>
                              </div>
                            </div>
                          </template>
                          <template v-if="order.type == 'self_ordering'">
                            <div class="form-group" >
                              <label>{{$t('settingsOrdering.maxDistanceInMeter')}}</label>  
                              <input type="number"
                                      min="0"
                                      :name="model.id + order.type + 'max_distance_in_meter'" class="form-control sml"
                                      v-model="order.max_distance_in_meter"
                                      :disabled="!order.enabled"
                                      placeholder=""
                                      v-validate="modelValidate.required">
                            </div>
                          </template>
                          <!-- /// -->
                          <template>
                            <div class="form-group">
                              <label>{{$t('settingCompany.closeOrders', {deliveryMethod: order.label})}}</label>
                              <select v-model="order.closeOrder"
                                    class="form-control sml"
                                    @input="handleClosingHour(orderIdx, $event)">
                                <option v-for="option in closeOrderOptions"
                                        :value="option.id"
                                        >{{option.label}}</option>
                              </select>
                              <template v-if="order.closeOrder">
                                <el-time-select
                                  placeholder="Select hour"
                                  v-model="order.auto_close_orders_at_hour"
                                  :picker-options="picker_options_orders_starts_from">
                                </el-time-select>
                              </template>
                              <template v-else>
                                <input
                                  class="form-control sml"
                                  :name="model.id + order.type + 'auto_close_orders_after_hour'"
                                  type="number"
                                  v-model="order.auto_close_orders_after_hour"
                                  min="0"
                                  max="12"
                                  placeholder="3"
                                  v-validate="modelValidate.auto_close_orders_after_hour">
                                <label>{{$t('settingsOrdering.hours')}}</label>
                                <label class="text-danger" v-show="errors.has(model.id + order.type + 'auto_close_orders_after_hour')">
                                  {{$t('settingsOrdering.closeOrderAfterHours')}}
                                </label>
                              </template>
                            </div>
                          </template>
                          <!-- /// -->
                          <template>
                            <div class="form-group">
                              <div class="checkbox mar-bt-20">
                                <input type="checkbox" 
                                        v-model="isAutoChangeEnabled[orderIdx]"
                                        @change="isAutoChangeEnabledChange(orderIdx)">
                                <label>{{$t('settingCompany.autoChangeStatus', {deliveryMethod: order.label})}}</label>
                              </div>
                              <template v-if="isAutoChangeEnabled[orderIdx]">
                                <select v-model="order.status_from_auto_change"
                                      class="form-control sml">
                                  <option v-for="option1 in statusesAutoChange"
                                          :value="option1.name"
                                          >{{option1.name}}</option>
                                </select>
                                ->
                                <select v-model="order.status_to_auto_change"
                                      class="form-control sml">
                                  <template v-for="option in statusesAutoChange">
                                    <template v-if="order.status_from_auto_change == option.name">
                                      <option v-for="option2 in option.values"
                                          :value="option2"
                                          >{{option2}}</option>
                                    </template>
                                  </template>
                                </select>
                                <input
                                    class="form-control sml"
                                    :name="model.id + order.type + 'auto_change_status_after_min'"
                                    type="number"
                                    v-model="order.auto_change_status_after_min"
                                    min="0"
                                    max="360"
                                    placeholder="1"
                                    v-validate="modelValidate.auto_change_status_after_min">
                                  <label>{{$t('settingsOrdering.minutes')}}</label>
                                  <label class="text-danger" v-show="errors.has(model.id + order.type + 'auto_change_status_after_min')">
                                    {{$t('settingsOrdering.errorAutoChangeStatusAfterMin')}}
                                  </label>
                              </template>
                            </div>
                          </template>
                          <template v-if="order.type != 'self_ordering' && !order.use_multiple_delivery_preferences">
                            <div class="form-group">
                              <label :for="'swPreorders_'+order.id" style="margin-right: 10px;">{{$t('settingsOrdering.noPreorders')}}</label>
                              <p-switch :name="'swPreorders_'+order.id" v-model="order.no_preorders" type="success"></p-switch>
                              <span v-if="order.offset > 0 || order.period > 1"> {{$t('settingsOrdering.offnoPreorders')}}</span>
                            </div>
                            <div class="form-group">
                              <label :for="'swAlwaysOpen_'+order.id" style="margin-right: 10px;">{{$t('settingsOrdering.isAlwaysOpen')}}</label>
                              <p-switch :name="'swAlwaysOpen_'+order.id" v-model="order.is_always_open" type="success"></p-switch>
                            </div>
                            <div class="form-group" v-if="order.is_always_open">
                              <label for="" style="margin-bottom: 12px;">
                                {{$t('settingsOrdering.isAlwaysOpenPreorderHours')}}
                                <input type="number"
                                  min="0"
                                  class="form-control"
                                  :name="model.id + order.type +'is_always_open_preorder_hours'"
                                  v-model="order.is_always_open_preorder_hours"
                                  :disabled="!order.enabled">
                              </label>
                            </div>
                            <label>{{$t('settingsOrdering.availableDays')}}</label>
                            <br/>
                            <label class="text-danger" v-show="errors.has(model.id + order.type + 'days')">{{$t('settingsOrdering.availableDaysErr')}}</label>
                            <div class="changeDeliveryDisponibility">
                              <div class="">
                                        <!-- v-if="order.type != 'eat_location' || (dusg.id != 2 && order.type === 'eat_location')" -->
                                <p-radio v-for="(dusg, dusgId) in delivery_hour_usage"
                                        :key="dusgId"
                                        v-model="order.delivery_hour_usage"
                                        @input="changeDeliveryHourUsage(order)"
                                        :label="dusgId"
                                        :inline="true">{{$t('settingsOrdering')[dusg.name] }}
                                </p-radio>
                              </div>
                              <hr/>
                            </div>
                          </template>
                          <template v-if="!order.use_multiple_delivery_preferences">
                            <template v-if="order.type != 'self_ordering' && !order.deactivate_delivery_hour_usage && !order.use_multiple_delivery_preferences">
                              <label for="" style="margin-bottom: 12px; margin-right: 10px;">
                                {{$t('settingsOrdering.offset')}}
                                <input type="number"
                                    min="0"
                                    class="form-control"
                                    :name="model.id + order.type +'offset'"
                                    v-validate="modelValidate.offset"
                                    v-model="order.offset"
                                    :disabled="order.is_always_open">
                              </label>
                              <label for="" style="margin-bottom: 12px;">
                                {{$t('settingsOrdering.period')}}
                                <input type="number"
                                    min="1"
                                    class="form-control" 
                                    :name="model.id + order.type +'period'"
                                    v-validate="modelValidate.period"
                                    v-model="order.period"
                                    :disabled="order.is_always_open">
                              </label>
                            </template>
                              
                            <div class="row" v-for="(day, dayIdx) in order.available_days" style="display: flex; align-items: flex-start; margin-bottom: 20px;">
                              <div class="col-md-6">
                                <div class="row">
                                  <div class="col-md-3 padd in-inline-160">
                                    <div class="checkbox">
                                      <input v-if="dayIdx == 0" type="checkbox" 
                                              :value="day.day"
                                              v-model="day.open"
                                              :name="model.id + order.type + 'days'"
                                              :id="model.id + order.type + day.day"
                                              v-validate="{required: true}"
                                              :disabled="!order.enabled || order.is_always_open"
                                              >
                                      <input v-else  type="checkbox" 
                                              :value="day.day"
                                              v-model="day.open"
                                              :name="model.id + order.type + 'days'"
                                              :id="model.id + order.type + day.day"
                                              :disabled="!order.enabled || order.is_always_open"
                                              >
                                      <label :for="model.id + order.type + day.day">{{$t('days.' + day.day) | capitalize}}</label>
                                    </div>
                                  </div>
                                  <div class="col-md-9 padd">
                                      from
                                      <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                      placeholder="Select time"
                                                      :value="day.open_from"
                                                      v-model="day.open_from"
                                                      v-validate="modelValidate.available_days"
                                                      :picker-options="pickerOptions">
                                      </el-time-select>
                                      to
                                      <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                      placeholder="Select time"
                                                      :value="day.open_to"
                                                      v-model="day.open_to"
                                                      v-validate="modelValidate.available_days"
                                                      :picker-options="pickerOptions">
                                      </el-time-select>
                                  </div>
                                  </div>
                                  <div class="row intervals" v-if="day.intervals">
                                  <template v-for="(interval, intervalKey) in day.intervals">
                                      <div class="col-md-3 padd in-inline-160"></div>
                                      <div class="col-md-9 padd">
                                      from
                                      <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                      placeholder="Select time"
                                                      :value="interval.open_from"
                                                      v-model="interval.open_from"
                                                      v-validate="modelValidate.available_days"
                                                      :picker-options="pickerOptions">
                                      </el-time-select>
                                      to
                                      <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                      placeholder="Select time"
                                                      :value="interval.open_to"
                                                      v-model="interval.open_to"
                                                      v-validate="modelValidate.available_days"
                                                      :picker-options="pickerOptions">
                                      </el-time-select>
                                      <button class="btn btn-simple btn-icon " :disabled="order.is_always_open" @click.prevent="deleteIntervals(intervalKey, dayIdx, orderIdx)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button>
                                  </div>
                                  </template>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <button class="btn add"
                                        @click.prevent="addMoreIntervals(dayIdx, orderIdx)"
                                        :disabled="order.is_always_open"
                                        :title="$t('general.add')  + ' moreIntervals'" >
                                  <img src="/static/img/icons/add.png">
                                  {{$t('general.add')}}
                                </button>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div class="form-group">
                          <hr>
                        </div>
                        <div class="row" v-if="order.type != 'self_ordering'">
                          <div class="col-md-12">
                            <div class="form-group">
                              <div class="card" style="box-shadow: none; border: 1px solid #dcdfe6;">
                                <div class="card-content">
                                  <div class="prod-tabs" direction="horizontal" type="tabs">
                                    <div class="col-md-12 display-flex align-items-center justify-content-space-between">
                                      <p>{{$t('settingsOrdering.infoBoxTitle')}}</p>
                                      <button class="btn add"
                                              @click.prevent="addMethodInfo(orderIdx)"
                                              :title="$t('general.add')  + ' ' + $t('catalogProdOpt.single')" >
                                          <img src="/static/img/icons/add.png">
                                          {{$t('general.add')}}
                                      </button>
                                    </div>
                                    <div class="col-md-12 pad-lf-0 pad-rg-0">
                                      <hr class="sm">
                                    </div>
                                    <div :title="$t('catalogProdOpt.plural')" class="text-left">
                                      <div class="row">
                                        <div class="col-md-12" >
                                          <p v-if="!order.method_info || (order.method_info && order.method_info.length == 0)" class="">No options added yet.</p>
                                          <el-collapse ref="elColl" v-model="methodInfoIndex" accordion>
                                            <template v-for="(option, idxO) in order.method_info">
                                              <div class="align">
                                                <el-collapse-item class="customItem" :title="option.title === '' ? 'Name' : option.title" :name="idxO">
                                                  <div class="clearfix"><hr class="no-margin mar-bt-15" /></div>
                                                    <div class="row">
                                                      <div class="col-md-6">
                                                          <div class="form-group">
                                                              <label>{{$t('catalogProd.name')}}</label>
                                                              <input type="text"
                                                                      name="name"
                                                                      :placeholder="$t('catalogProd.name')"
                                                                      v-validate="'required'"
                                                                      v-model="option.title"
                                                                      class="form-control">
                                                              <small class="text-danger" v-if="errors.has('name')">
                                                              {{ getError('name') }}
                                                              </small>
                                                          </div>
                                                      </div>
                                                      <div class="col-md-6">
                                                        <div class="form-group">
                                                          <label>{{$t('settingsOrdering.infoBoxRadioCheck')}}</label>
                                                          <select class="form-control" v-model="option.type">
                                                            <option value="check">{{$t('settingsOrdering.infoBoxCheck')}}</option>
                                                            <option value="radio">{{$t('settingsOrdering.infoBoxRadio')}}</option>
                                                          </select>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <table class="table no-margin">
                                                      <thead>
                                                        <tr>
                                                          <th style="min-width: 200px">{{$t('catalogProd.optVal')}}</th>
                                                          <th>{{$t('general.delete')}}</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr v-for="(value, idx) in option.options">
                                                          <td>
                                                            <div class="row">
                                                              <div class="col-md-12">
                                                                <input 
                                                                  type="text"
                                                                  class="form-control"
                                                                  v-model="value.title">
                                                              </div>
                                                            </div>
                                                          </td>
                                                          <td><button class="btn btn-simple btn-icon " @click.prevent="deleteMethodInfoOptionValue(orderIdx, idxO, idx)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button></td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <div class="pull-right">
                                                    <button  class="btn add mar-bt-5" @click.prevent="addMethodInfoOptionValue(orderIdx, idxO)">
                                                      <img src="/static/img/icons/add.png">
                                                      {{$t('general.add')}}
                                                    </button>
                                                  </div>
                                                </el-collapse-item>
                                                <div class="closeBtn">
                                                  <button class="btn btn-danger pull-left btn-icon mar-15" :title="$t('general.delete')" @click.prevent="deleteMethodInfo(orderIdx, idxO)"><i class="ti-close"></i></button>
                                                </div>
                                              </div>
                                            </template>
                                          </el-collapse>
                                        </div>
                                        <div class="col-md-12 pad-to-15 pad-bt-10">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </form>
                  </el-collapse-item>
                </template>
              </template>
            </el-collapse>
          </form>
        </div>
      </div>
    </div>

    <vmodal name="copyDeliveryRangesModal" height="600" width="900">
    <div class="card copy-delivery-ranges-modal">
      <div class="card-content">
        <h4>{{ $t('settingsOrdering.copyRangesFromLocation') }}</h4>

        <div class="copy-delivery-ranges-body">
          <div class="form-group">
            <label>{{ $t('settingsOrdering.location') }}</label>
            <select
              class="form-control"
              v-model="copyDeliveryRangesLocationToken"
              @change="handleCopyDeliveryRangesLocationChange"
            >
              <option value="">{{ $t('settingsOrdering.selectLocation') }}</option>
              <option
                v-for="loc in copyDeliveryRangesLocations"
                :key="'copy-ranges-loc-' + (loc.token || loc.id)"
                :value="loc.token"
              >
                {{ loc.name || loc.label || loc.token }}
              </option>
            </select>
          </div>

          <div class="form-group" v-if="copyDeliveryRangesLoading">
            <p>{{ $t('general.loading') }}</p>
          </div>

          <div class="form-group" v-else>
            <label>{{ $t('settingsOrdering.ranges') }}</label>
            <div v-if="!copyDeliveryRangesFetched || !copyDeliveryRangesFetched.length" class="text-muted">
              {{ copyDeliveryRangesLocationToken ? $t('general.no_data') : $t('settingsOrdering.selectLocationToLoadRanges') }}
            </div>
            <div v-else class="copy-ranges-list">
              <div
                v-for="(z, idx) in copyDeliveryRangesFetched"
                :key="'copy-range-zone-' + idx"
                class="copy-range-item"
              >
                <strong>{{ z.name || $t('settingsOrdering.newZone') }}</strong>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer copy-delivery-ranges-footer">
          <button class="btn btn-danger" @click.prevent="closeCopyDeliveryRangesModal">
            {{ $t('general.cancel') }}
          </button>
          <button
            class="btn btn-icon btn-success save"
            :disabled="copyDeliveryRangesLoading || !copyDeliveryRangesFetched || !copyDeliveryRangesFetched.length"
            @click.prevent="confirmCopyDeliveryRanges"
          >
            <img src="/static/img/icons/save.png">
            {{ $t('general.copy') }}
          </button>
        </div>
      </div>
    </div>
  </vmodal>
</div>
</template>

<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, TimeSelect} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import ZoneAvailabilityEditor from './../DeliveryPreferences/ZoneAvailabilityEditor.vue'
  import { zoneAvailabilityError } from './../DeliveryPreferences/zoneAvailability'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import vSelect from 'vue-select'
  import DeliveryGoogleMaps from './../../Maps/DeliveryGoogleMaps.vue'
  import DeliveryTaxPanel from './../Taxes/DeliveryTaxPanel.vue'
  import draggable from 'vuedraggable'
  Vue.component('v-select', vSelect)
  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  export default {
    components: {
      ZoneAvailabilityEditor,
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      DeliveryGoogleMaps,
      DeliveryTaxPanel,
      PSwitch,
      draggable
    },
    computed: {
      ...mapFields(['name', 'description', 'sku', 'category_id', 'sub_category_id', 'date_from', 'date_to', 'price', 'quantity']),
      copyDeliveryRangesLocations () {
        const sessionCompany = this.$session && this.$session.get ? this.$session.get('selectedCompanyData') : null
        const all =
          (this.model && Array.isArray(this.model.locations_details)) ? this.model.locations_details
            : (sessionCompany && Array.isArray(sessionCompany.locations_details)) ? sessionCompany.locations_details
              : []
        const currentToken = this.model && this.model.token ? this.model.token : null
        return all.filter(l => l && l.token && l.token !== currentToken)
      },
      reservationWidgetCompanyId () {
        return this.$session.get('selectedCompany')
      },
      reservationWidgetButtonLabel () {
        const labels = {
          ro: 'Rezerva o masa',
          en: 'Reserve a table'
        }
        return labels[this.reservationWidget.language] || labels.ro
      },
      reservationWidgetPositions () {
        return [
          { id: 'top-left', label: this.$t('settingsOrdering.reservationWidgetPosTopLeft') },
          { id: 'top-right', label: this.$t('settingsOrdering.reservationWidgetPosTopRight') },
          { id: 'bottom-left', label: this.$t('settingsOrdering.reservationWidgetPosBottomLeft') },
          { id: 'bottom-right', label: this.$t('settingsOrdering.reservationWidgetPosBottomRight') }
        ]
      }
    },
    props: {
      defaultData: {},
      modeldata: {},
      drawDetails: {}
    },
    watch: {
      defaultData (value) {
        this.defaults = value
      },
      'model.name' (value) {
        if (value && !this.reservationWidget.restaurantNameCustomized) {
          this.reservationWidget.restaurantName = value
        }
      },
      modeldata (value) {
        for (var iLocation in value.locations_details) {
          for (var iOrder in value.locations_details[iLocation].ordering_management) {
            // set default value for locations
            if (value.locations_details[iLocation].ordering_management[iOrder].locations === undefined) {
              value.locations_details[iLocation].ordering_management[iOrder].locations = []
            }
            // set default value for interval_days_usage
            // if (value.locations_details[iLocation].ordering_management[iOrder].interval_days_usage === undefined) {
            //   Vue.set(value.locations_details[iLocation].ordering_management[iOrder], 'interval_days_usage', 1)
            // }
            // set default value for hour_and_day_delivery_hour_usage
            if (value.locations_details[iLocation].ordering_management[iOrder].period === undefined) {
              Vue.set(value.locations_details[iLocation].ordering_management[iOrder], 'period', 1)
            }
            if (value.locations_details[iLocation].ordering_management[iOrder].offset === undefined) {
              Vue.set(value.locations_details[iLocation].ordering_management[iOrder], 'offset', 0)
            }
            if (value.locations_details[iLocation].ordering_management[iOrder].no_preorders === undefined) {
              Vue.set(value.locations_details[iLocation].ordering_management[iOrder], 'no_preorders', false)
            }
            if (value.locations_details[iLocation].ordering_management[iOrder].is_always_open === undefined) {
              Vue.set(value.locations_details[iLocation].ordering_management[iOrder], 'is_always_open', false)
            }
            if (value.locations_details[iLocation].ordering_management[iOrder].is_always_open_preorder_hours === undefined) {
              Vue.set(value.locations_details[iLocation].ordering_management[iOrder], 'is_always_open_preorder_hours', 0)
            }
            if (
              (value.locations_details[iLocation].ordering_management[iOrder].hour_and_date_delivery_hour_usage === undefined ||
                !value.locations_details[iLocation].ordering_management[iOrder].hour_and_date_delivery_hour_usage) &&
              (value.locations_details[iLocation].ordering_management[iOrder].just_date_delivery_hour_usage === undefined ||
                !value.locations_details[iLocation].ordering_management[iOrder].just_date_delivery_hour_usage) &&
              (value.locations_details[iLocation].ordering_management[iOrder].deactivate_delivery_hour_usage === undefined ||
               !value.locations_details[iLocation].ordering_management[iOrder].deactivate_delivery_hour_usage)
              ) {
              Vue.set(value.locations_details[iLocation].ordering_management[iOrder], 'delivery_hour_usage', 0)
              this.changeDeliveryHourUsage(value.locations_details[iLocation].ordering_management[iOrder])
            }
            // set default value for shipping cost object
            if (value.locations_details[iLocation].ordering_management[iOrder].shipping_cost === undefined) {
              value.locations_details[iLocation].ordering_management[iOrder].shipping_cost = []
            }
            if (value.locations_details[iLocation].ordering_management[iOrder].delivery_rules === undefined) {
              let newRow = this.copyObject(this.newRule)
              let newSubRule = this.copyObject(this.newSubRule)
              newRow.subrules = []
              newRow.subrules.push(newSubRule)
              value.locations_details[iLocation].ordering_management[iOrder].delivery_rules = []
              value.locations_details[iLocation].ordering_management[iOrder].delivery_rules.push(newRow)
            }
            if (value.locations_details[iLocation].ordering_management[iOrder].area === undefined && value.locations_details[iLocation].ordering_management[iOrder].type === 'delivery') {
              value.locations_details[iLocation].ordering_management[iOrder].area = 'radius'
            }
            // set default values for the available days and hours objects
            for (var iDay in this.days) {
              var day = this.days[iDay]
              if (value.locations_details[iLocation].ordering_management[iOrder].available_days === undefined) {
                value.locations_details[iLocation].ordering_management[iOrder].available_days = []
              }
              var index = this.getObjectByElemKeyValue('day', day, value.locations_details[iLocation].ordering_management[iOrder].available_days)
              if (index === false) {
                value.locations_details[iLocation].ordering_management[iOrder].available_days.push({day: day, open_to: '', open_from: '', open: false})
              } else if (value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open === undefined) {
                if (value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open_to !== '' &&
                    value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open_from !== '') {
                  value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open = true
                } else {
                  value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open = false
                }
              }
            }
            // clean available days -- bug after days number got dubled because of translation
            let self = this
            value.locations_details[iLocation].ordering_management[iOrder].available_days = value.locations_details[iLocation].ordering_management[iOrder].available_days.filter(function (value, index, arr) {
              return (self.days.indexOf(value.day) !== -1)
            })
          }
        }
        this.model = value
      }
    },
    data () {
      return {
        showTheRestOfTheZones: true,
        copyDeliveryRangesLocationToken: '',
        copyDeliveryRangesFetched: [],
        copyDeliveryRangesLoading: false,
        deliveryRangesDataReady: false,
        isAutoChangeEnabled: [],
        deliveryMethodLabels: [],
        reservationTaxesIndex: 0,
        methodInfoIndex: 0,
        closeOrderOptions: [{'id': 0, 'label': this.$t('settingCompany.closeOrdersAfter')}, {'id': 1, 'label': this.$t('settingCompany.closeOrdersAt')}],
        delivery_hour_usage: [
          {
            'id': 0,
            'name': 'hourAndDate'
          },
          {
            'id': 1,
            'name': 'justDate'
          },
          {
            'id': 2,
            'name': 'deactivateDeliveryHours'
          }
        ],
        arrowsSimbolHtml: '<i style="cursor: move" class="fa fa-arrows sortHandle"></i>',
        colapsedItem: null,
        model: this.modeldata,
        deliveryRanges: [],
        defaults: this.value || this.defaultData, // this.countries
        pickerOptions1: {},
        pickerOptionsTaxFrom: {
          disabledDate (time) {
            if ((time.getTime() + 86401 * 1000) < Date.now()) {
              return true
            } else {
              return false
            }
          }
        },
        pickerOptionsTaxTo: {
          disabledDate (time) {
            if ((time.getTime() + 86401 * 1000) < Date.now()) {
              return true
            } else {
              return false
            }
          }
        },
        tabIndex: 0,
        taxes: [],
        taxesPerLocation: [],
        activeNames: [],
        currency: this.$session.get('selectedCompanyData')['currency_iso'],
        modelValidate: {
          'available_days': { required: true },
          'required': { required: true },
          'offset': { required: true, min_value: 0, max_value: 365, decimal: 0 },
          'period': { required: true, min_value: 1, max_value: 1095, decimal: 0 },
          'auto_close_orders_after_hour': { min_value: 0, max_value: 12, decimal: 0 },
          'auto_change_status_after_min': { min_value: 0, max_value: 360, decimal: 0 }
        },
        statusesAutoChange: [
          {
            name: 'NEW',
            values: ['PROCESSING', 'PREPARED']
          },
          {
            name: 'PROCESSING',
            values: ['PREPARED']
          },
          {
            name: 'PREPARED',
            values: ['DELIVERED']
          }
        ],
        paymentOptions: [
          {
            'payment_id': 'credit_card',
            'name': this.$t('paymentTypes.CARD')
          },
          {
            'payment_id': 'cash',
            'name': this.$t('paymentTypes.CASH')
          },
          {
            'payment_id': 'pos',
            'name': this.$t('paymentTypes.POS')
          },
          {
            'payment_id': 'kiosk_pos',
            'name': this.$t('paymentTypes.POS_KIOSK')
          }
        ],
        pickerNames: ['date_from', 'date_to'],
        days: [
          'monday',
          'tuesday',
          'wednesday',
          'thursday',
          'friday',
          'saturday',
          'sunday'
        ],
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '24:00'
        },
        picker_options_orders_starts_from: {
          start: '00:00',
          step: '01:00',
          end: '24:00'
        },
        newLocation: {
          street: '',
          city: '',
          state: '',
          country: ''
        },
        newRule: {
          delivery_range: '',
          subrules: []
        },
        newSubRule: {
          shipping_cost: 0,
          shipping_pos_id: '',
          vat_rate_id: null,
          cities: [],
          neighborhoods: [],
          min_order_value: 0
        },
        zoneLimitations: {
          'radius': 'setRadiusArea',
          'draw': 'setDrawArea'
        },
        windowHeight: 0,
        navbarHeaderHeight: 0,
        pageTopHeight: 76,
        loading: true,
        vatOptions: [],
        deliveryPreferencesList: [],
        preferenceSearch: '',
        taxesVersion: Number((this.$session.get('selectedCompanyData') || {}).taxes_version || 1),
        defaultDeliveryMethods: [],
        tableZones: [],
        reservationWidgetLanguages: [
          { id: 'ro', label: 'Română' },
          { id: 'en', label: 'English' }
        ],
        reservationWidget: {
          position: 'bottom-right',
          language: 'ro',
          hoursToStay: 2,
          defaultPersons: 2,
          tableZoneId: 0,
          countryCodePrefix: '40',
          restaurantName: '',
          restaurantNameCustomized: false,
          copied: false
        }
      }
    },
    created () {
      const requestsToComplete = {
        vat: false,
        tableZones: false,
        deliveryRanges: false
      }

      const checkAllComplete = () => {
        if (Object.values(requestsToComplete).every(v => v === true)) {
          this.$bus.$emit('delivery-methods-loaded')
        }
      }

      this.getVatOptions(() => {
        requestsToComplete.vat = true
        checkAllComplete()
      })
      this.getTableZones(() => {
        requestsToComplete.tableZones = true
        checkAllComplete()
      })
      this.$nextTick(() => {
        this.loading = false
      })
      this.getData(() => {
        requestsToComplete.deliveryRanges = true
        checkAllComplete()
      })
      if (this.model) {
        console.log(this.model)
        for (var iOrder in this.model.ordering_management) {
          if (this.model.ordering_management[iOrder].auto_close_orders_at_hour) {
            Vue.set(this.model.ordering_management[iOrder], 'closeOrder', 1)
          } else {
            Vue.set(this.model.ordering_management[iOrder], 'closeOrder', 0)
          }
          if (this.model.ordering_management[iOrder].is_always_open === undefined || this.model.ordering_management[iOrder].is_always_open === null) {
            Vue.set(this.model.ordering_management[iOrder], 'is_always_open', false)
          } else {
            Vue.set(this.model.ordering_management[iOrder], 'is_always_open', Boolean(this.model.ordering_management[iOrder].is_always_open))
          }
          if (this.model.ordering_management[iOrder].is_always_open_preorder_hours === undefined || this.model.ordering_management[iOrder].is_always_open_preorder_hours === null) {
            Vue.set(this.model.ordering_management[iOrder], 'is_always_open_preorder_hours', 0)
          }
          // Delivery preferences opt-in flag + chosen preferences (per method)
          // New methods (no saved value yet) default ON for delivery; existing methods keep their stored value.
          if (this.model.ordering_management[iOrder].use_multiple_delivery_preferences === undefined || this.model.ordering_management[iOrder].use_multiple_delivery_preferences === null) {
            Vue.set(this.model.ordering_management[iOrder], 'use_multiple_delivery_preferences', this.model.ordering_management[iOrder].type === 'delivery')
          } else {
            Vue.set(this.model.ordering_management[iOrder], 'use_multiple_delivery_preferences', Boolean(this.model.ordering_management[iOrder].use_multiple_delivery_preferences))
          }
          if (!Array.isArray(this.model.ordering_management[iOrder].delivery_preference_ids)) {
            Vue.set(this.model.ordering_management[iOrder], 'delivery_preference_ids', [])
          }
        }
      }
      this.deliveryMethodLabels = this.getCompanyDetail('delivery_options_labels')
      this.getDeliveryPreferences()
      this.model.ordering_management.forEach((order, orderIdx) => {
        if (order.status_from_auto_change != null ||
            order.status_to_auto_change != null ||
            order.auto_change_status_after_min != null
            ) {
          this.isAutoChangeEnabled[orderIdx] = true
        }
      })
      this.initReservationWidgetDefaults()
    },
    methods: {
      initReservationWidgetDefaults () {
        if (this.model && this.model.name && !this.reservationWidget.restaurantName) {
          this.reservationWidget.restaurantName = this.model.name
        }
        const eatOrder = (this.model && this.model.ordering_management)
          ? this.model.ordering_management.find(o => o.type === 'eat_location')
          : null
        if (eatOrder && eatOrder.min_standard_reservations) {
          this.reservationWidget.hoursToStay = Number(eatOrder.min_standard_reservations) || 2
        }
        if (eatOrder && eatOrder.min_reservation) {
          this.reservationWidget.defaultPersons = Number(eatOrder.min_reservation) || 2
        }
      },
      escapeWidgetAttr (value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/"/g, '&quot;')
          .replace(/</g, '&lt;')
      },
      getReservationWidgetScript (order) {
        const widget = this.reservationWidget
        const restaurantName = widget.restaurantName || (this.model && this.model.name) || ''
        const methodId = (order && order.id) ? order.id : ''
        const locationToken = (this.model && this.model.token) ? this.model.token : ''
        const scriptClose = '</' + 'script>'
        return [
          '<script src="https://reservationswidget.taptasty.ro/reservations-widget.env.production.js">' + scriptClose,
          '<script',
          '  src="https://reservationswidget.taptasty.ro/reservations-widget.js"',
          '  data-company-id="' + this.escapeWidgetAttr(this.reservationWidgetCompanyId) + '"',
          '  data-method-id="' + this.escapeWidgetAttr(methodId) + '"',
          '  data-location-token="' + this.escapeWidgetAttr(locationToken) + '"',
          '  data-position="' + this.escapeWidgetAttr(widget.position) + '"',
          '  data-language="' + this.escapeWidgetAttr(widget.language) + '"',
          '  data-hours-to-stay="' + this.escapeWidgetAttr(widget.hoursToStay) + '"',
          '  data-default-persons="' + this.escapeWidgetAttr(widget.defaultPersons) + '"',
          '  data-table-zone-id="' + this.escapeWidgetAttr(widget.tableZoneId) + '"',
          '  data-country-code-prefix="' + this.escapeWidgetAttr(widget.countryCodePrefix) + '"',
          '  data-restaurant-name="' + this.escapeWidgetAttr(restaurantName) + '"',
          '>' + scriptClose
        ].join('\n')
      },
      fallbackCopyReservationWidgetScript (script, done) {
        const textarea = document.createElement('textarea')
        textarea.value = script
        textarea.setAttribute('readonly', '')
        textarea.style.position = 'absolute'
        textarea.style.left = '-9999px'
        document.body.appendChild(textarea)
        textarea.select()
        try {
          document.execCommand('copy')
          if (done) done()
        } catch (err) {
          console.error('Copy failed', err)
        }
        document.body.removeChild(textarea)
      },
      copyReservationWidgetScript (order) {
        const script = this.getReservationWidgetScript(order)
        const done = () => {
          this.reservationWidget.copied = true
          setTimeout(() => {
            this.reservationWidget.copied = false
          }, 2000)
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(script).then(done).catch(() => {
            this.fallbackCopyReservationWidgetScript(script, done)
          })
        } else {
          this.fallbackCopyReservationWidgetScript(script, done)
        }
      },
      handleUpdateZone (zone, indexZone) {
        this.deliveryRanges[indexZone] = zone
      },
      handleClosingHour (orderIdx, e) {
        if (parseInt(e.target.value)) {
          this.model.ordering_management[orderIdx].auto_close_orders_after_hour = null
        } else {
          this.model.ordering_management[orderIdx].auto_close_orders_at_hour = null
        }
      },
      getTableZones (callback) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/table-zone', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableZones = response.data
          }
          if (callback) callback()
        })
      },
      getVatOptions (callback, locaitonIds = null) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_ids: locaitonIds
        }
        const endpoint = this.taxesVersion === 2 ? '/taxes-v2/vat-rates' : '/location/vat'
        this.apiRequest(endpoint, 'GET', data, (response) => {
          if (response.status === true) {
            this.vatOptions = response.data
          }
          if (callback) callback()
        })
      },
      getDeliveryPreferences () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/delivery-preference', 'GET', data, (response) => {
          if (response.status === true) {
            this.deliveryPreferencesList = response.data
          }
        })
      },
      // Preferences picker (scrollable, searchable checkbox list) on the delivery method.
      filteredPreferences () {
        const q = (this.preferenceSearch || '').toLowerCase().trim()
        if (!q) return this.deliveryPreferencesList
        return this.deliveryPreferencesList.filter((p) => {
          const admin = (p.nume_admin || '').toLowerCase()
          const name = (p.name || '').toLowerCase()
          return admin.indexOf(q) !== -1 || name.indexOf(q) !== -1
        })
      },
      isPreferenceChecked (order, id) {
        return Array.isArray(order.delivery_preference_ids) && order.delivery_preference_ids.indexOf(id) !== -1
      },
      togglePreference (order, id) {
        if (!Array.isArray(order.delivery_preference_ids)) {
          this.$set(order, 'delivery_preference_ids', [])
        }
        const i = order.delivery_preference_ids.indexOf(id)
        if (i === -1) {
          order.delivery_preference_ids.push(id)
        } else {
          order.delivery_preference_ids.splice(i, 1)
        }
      },
      getData (callback) {
        this.getDeliveryRanges(callback)
        this.$bus.$on('drawingDetails', this.drawing) // listener for event from map
        this.$bus.$on('changeDeliveryZone', this.changeDeliveryZone) // listener for event from map
        this.currency = this.getCurrencySymbol(this.currency)
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      getDeliveryRanges (callback) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_token: this.model.token
        }
        this.apiRequest('/admin/delivery-ranges', 'GET', data, (response) => {
          if (response.status === true) {
            this.deliveryRanges = Array.isArray(response.data) ? response.data : []
            this.$nextTick().then(() => {
              this.deliveryRangesDataReady = true
              if (callback) callback()
            })
          } else {
            if (callback) callback()
          }
        })
      },
      openCopyDeliveryRangesModal () {
        this.copyDeliveryRangesLocationToken = ''
        this.copyDeliveryRangesFetched = []
        this.copyDeliveryRangesLoading = false
        this.$modal.show('copyDeliveryRangesModal')
      },
      closeCopyDeliveryRangesModal () {
        this.$modal.hide('copyDeliveryRangesModal')
      },
      handleCopyDeliveryRangesLocationChange () {
        const token = this.copyDeliveryRangesLocationToken
        if (!token) {
          this.copyDeliveryRangesFetched = []
          return
        }
        this.copyDeliveryRangesLoading = true
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_token: token
        }
        this.apiRequest('/admin/delivery-ranges', 'GET', data, (response) => {
          if (response && response.status === true && Array.isArray(response.data)) {
            this.copyDeliveryRangesFetched = response.data
          } else {
            this.copyDeliveryRangesFetched = []
            swal({ 'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(() => {})
          }
          this.$nextTick(() => {
            this.copyDeliveryRangesLoading = false
          })
        })
      },
      confirmCopyDeliveryRanges () {
        if (!Array.isArray(this.copyDeliveryRangesFetched) || !this.copyDeliveryRangesFetched.length) {
          return
        }
        if (!Array.isArray(this.deliveryRanges)) {
          this.deliveryRanges = []
        }
        const isBlankZone = (z) => {
          if (!z) return true
          const name = (z.name || '').toString().trim()
          const shape = z.shape
          const shapeEmpty =
            !shape ||
            (Array.isArray(shape) && shape.length === 0) ||
            (typeof shape === 'object' && !Array.isArray(shape) && Object.keys(shape).length === 0)
          return name === '' && shapeEmpty
        }

        // Also copy Google Maps API key from the selected location
        const sessionCompany = this.$session && this.$session.get ? this.$session.get('selectedCompanyData') : null
        const allLocations =
          (this.model && Array.isArray(this.model.locations_details)) ? this.model.locations_details
            : (sessionCompany && Array.isArray(sessionCompany.locations_details)) ? sessionCompany.locations_details
              : []
        const sourceLocation = allLocations.find(l => l && l.token === this.copyDeliveryRangesLocationToken)
        if (sourceLocation && sourceLocation.google_maps_api_key) {
          Vue.set(this.model, 'google_maps_api_key', sourceLocation.google_maps_api_key)
        }

        const currentLocationId =
          (this.model && this.model.true_id) ? this.model.true_id
            : (this.model && this.model.id) ? this.model.id
              : null

        // If target has the auto-created empty zone, remove it before copying.
        this.deliveryRanges = this.deliveryRanges.filter(z => !isBlankZone(z))

        // Ensure we clone an array, not an object (copyObject may not preserve arrays).
        // Strip zone + cost-rule ids so save creates new rows instead of updating the source.
        const cloned = JSON.parse(JSON.stringify(this.copyDeliveryRangesFetched))
        cloned.filter(z => !isBlankZone(z)).forEach(z => {
          if (!z) return
          if (z && z.hasOwnProperty('id')) delete z.id
          z.location_id = currentLocationId
          if (!z.hasOwnProperty('name')) z.name = ''
          if (!z.hasOwnProperty('shape')) z.shape = {}
          if (Array.isArray(z.delivery_range_cost_rules)) {
            z.delivery_range_cost_rules.forEach(rule => {
              if (!rule) return
              if (rule.hasOwnProperty('id')) delete rule.id
              if (rule.hasOwnProperty('delivery_ranges_id')) delete rule.delivery_ranges_id
              rule.location_id = currentLocationId
            })
          }
          this.deliveryRanges.push(z)
        })
        this.deliveryRangesDataReady = true
        this.model.mapactive = this.deliveryRanges.length ? (this.deliveryRanges.length - 1) : null
        this.closeCopyDeliveryRangesModal()
      },
      validate () {
        var self = this
        this.errors.clear()
        const normalizeTimeValue = (val) => {
          if (val === null) return ''
          if (val === undefined) return ''
          if (typeof val === 'object' && Object.keys(val).length === 0) return ''
          if (Array.isArray(val) && val.length === 0) return ''
          return val
        }
        this.model.ordering_management.forEach(order => {
          if (!order.available_days) return
          order.available_days.forEach(day => {
            day.open_from = normalizeTimeValue(day.open_from)
            day.open_to = normalizeTimeValue(day.open_to)
            if (day.intervals) {
              day.intervals.forEach(interval => {
                interval.open_from = normalizeTimeValue(interval.open_from)
                interval.open_to = normalizeTimeValue(interval.open_to)
              })
            }
          })
        })
        // Return a promise that resolves to the validation result
        return new Promise((resolve) => {
          this.$validator.validateAll().then(isValid => {
            if (isValid) {
              // Perform manual validation of ranges
              for (let oIdx in this.model.ordering_management) {
                let o = this.model.ordering_management[oIdx]
                if (o.type === 'delivery') {
                  if (o.delivery_rules && o.delivery_rules.length > 1) {
                    for (let rIdx in o.delivery_rules) {
                      let rule = o.delivery_rules[rIdx]
                      if (rule.delivery_range.trim() === '') {
                        self.errors.add(this.model.id + o.type + 'delivery_range' + rIdx, 'invalid')
                        isValid = false
                      } else {
                        for (let r2Idx in o.delivery_rules) {
                          let rule2 = o.delivery_rules[r2Idx]
                          if (rule.delivery_range === rule2.delivery_range && rIdx !== r2Idx) {
                            self.errors.add(this.model.id + o.type + 'delivery_range' + rIdx, 'invalid')
                            self.errors.add(this.model.id + o.type + 'delivery_range' + r2Idx, 'invalid')
                            isValid = false
                          }
                        }
                      }
                    }
                  }

                  // Validate locations
                  if (o.delivery_rules && o.delivery_rules.length && o.enabled) {
                    let uniqueCities = []
                    for (let rIdx3 in o.delivery_rules) {
                      if (o.delivery_rules[rIdx3].subrules !== undefined && o.delivery_rules[rIdx3].subrules.length > 1) {
                        uniqueCities = []
                        let subrules = o.delivery_rules[rIdx3].subrules
                        for (let subrule of subrules) {
                          if (subrule.cities.length) {
                            for (let city of subrule.cities) {
                              if (uniqueCities.indexOf(city) > -1 && (subrule.neighborhoods === undefined || !subrule.neighborhoods.length)) {
                                swal({ 'text': self.$t('settingsOrdering.citiesValidationError'), 'type': 'error', 'showConfirmButton': true }).catch(() => {})
                                isValid = false
                                resolve(false) // Resolve with false immediately if invalid
                                return
                              } else {
                                uniqueCities.push(city)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            // Always validate map "extra cost range" rules (distance_in_km is mandatory),
            // regardless of whether other validations passed and regardless of open tabs.
            const isEmpty = (v) => v === '' || v === null || typeof v === 'undefined'
            let preserveActiveNames = false
            if (Array.isArray(this.deliveryRanges)) {
              for (let zIdx = 0; zIdx < this.deliveryRanges.length; zIdx++) {
                const zone = this.deliveryRanges[zIdx]
                const rules = (zone && Array.isArray(zone.delivery_range_cost_rules)) ? zone.delivery_range_cost_rules : []
                for (let rIdx = 0; rIdx < rules.length; rIdx++) {
                  const rule = rules[rIdx]
                  if (rule && !rule.deleted && isEmpty(rule.distance_in_km)) {
                    Vue.set(rule, '__distance_required_error', Date.now())
                    isValid = false
                    preserveActiveNames = true
                    // Bring user to the problematic zone in the UI.
                    this.model.mapactive = zIdx
                    // Ensure the delivery method tab stays open so the user can see the red field.
                    const deliveryTab = this.model.id + 'delivery'
                    if (this.activeNames.indexOf(deliveryTab) === -1) {
                      this.activeNames = [deliveryTab]
                    }
                    swal({
                      text: `${this.$t('settingsOrdering.distanceInKm')} is required.`,
                      type: 'error',
                      showConfirmButton: true
                    }).catch(() => {})
                    break
                  }
                }
                if (!isValid && preserveActiveNames) break
              }
            }

            // Zone availability schedule (complete intervals, from < to, no overlap).
            if (isValid && Array.isArray(this.deliveryRanges)) {
              for (let zIdx = 0; zIdx < this.deliveryRanges.length; zIdx++) {
                const zone = this.deliveryRanges[zIdx]
                const availabilityError = zoneAvailabilityError(zone, this.$t.bind(this))
                if (availabilityError) {
                  Vue.set(zone, '__availability_error', Date.now())
                  isValid = false
                  preserveActiveNames = true
                  this.model.mapactive = zIdx
                  const deliveryTab = this.model.id + 'delivery'
                  if (this.activeNames.indexOf(deliveryTab) === -1) {
                    this.activeNames = [deliveryTab]
                  }
                  break
                }
              }
            }

            this.$nextTick().then(() => {
              if (isValid) {
                resolve(true)
              } else {
                if (!preserveActiveNames) this.activeNames = []
                // Check which tabs have errors
                for (var order of this.model.ordering_management) {
                  var tabTtl = this.model.id + order.type
                  if (order.enabled && this.errors.items.length) {
                    // Check this.errors.items
                    for (var err of this.errors.items) {
                      if (err.field.includes(tabTtl)) {
                        this.activeNames.push(tabTtl)
                      }
                    }
                  }
                }
                swal({ 'text': this.$t('settingsOrdering.notice'), 'type': 'error' })
                resolve(false)
              }
            })
          })
        })
      },
      showStateDrop (location) {
        var countryIso = location.country
        var countries = this.$session.get('defaultData').countries
        var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)
        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          return true
        } else {
          return false
        }
      },
      getStatesOptions (location) {
        var countryIso = location.country
        var countries = this.$session.get('defaultData').countries
        var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)
        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          return countries[countryIdx].states
        } else {
          return []
        }
      },
      updateCountry (location) {
        location.state = null
        location.state_id = null
      },
      addNewLocation (locId, type) {
        var data = {
          'token': this.$session.get('token'),
          'type': 'hashes'
        }

        this.apiRequest('/helpers', 'GET', data, (response) => {
          if (response.status) {
            let newRow = []
            newRow = this.copyObject(this.newLocation)
            newRow.id = response.data[0].id
            var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.ordering_management)
            this.model.ordering_management[typeIdx].locations.push(newRow)
          } else {
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      addNewRule (locId, type) {
        this.$nextTick(function () {
          var self = this
          let newRow = []
          newRow = this.copyObject(self.newRule)
          let newSubRule = this.copyObject(self.newSubRule)
          var typeIdx = self.getObjectByElemKeyValue('type', type, self.model.ordering_management)
          this.$nextTick().then(function () {
            // newRow.shipping_cost = 0
            newRow.subrules = []
            newRow.subrules.push(newSubRule)
            if (self.model.ordering_management[typeIdx].delivery_rules) {
              self.model.ordering_management[typeIdx].delivery_rules.push(newRow)
            } else {
              self.model.ordering_management[typeIdx].delivery_rules = []
              self.model.ordering_management[typeIdx].delivery_rules.push(newRow)
            }
          })
        })
      },
      addNewSubRule (locId, type, idx) {
        this.$nextTick(function () {
          var self = this
          let newRow = []
          newRow = this.copyObject(self.newSubRule)
          var typeIdx = self.getObjectByElemKeyValue('type', type, self.model.ordering_management)
          let subrules = this.model.ordering_management[typeIdx].delivery_rules[idx]['subrules']
          this.$nextTick().then(function () {
            if (subrules) {
              self.model.ordering_management[typeIdx].delivery_rules[idx]['subrules'].push(newRow)
            } else {
              self.model.ordering_management[typeIdx].delivery_rules[idx]['subrules'] = []
              self.model.ordering_management[typeIdx].delivery_rules[idx]['subrules'].push(newRow)
            }
          })
        })
      },
      updateTabs (name, enabled) {
        this.$nextTick(function () {
          if (!enabled) {
            this.activeNames = [name]
          } else {
            this.activeNames = []
          }
        })
      },
      removeLocation (locId, idx, type) {
        var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.ordering_management)
        this.model.ordering_management[typeIdx].locations.splice(idx, 1)
      },
      removeRule (locId, idx, type) {
        this.$nextTick(function () {
          var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.ordering_management)
          this.$nextTick(function () {
            this.model.ordering_management[typeIdx].delivery_rules.splice(idx, 1)
          })
        })
      },
      removeSubRule (locId, idx, idxSubrule, type) {
        this.$nextTick(function () {
          var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.ordering_management)
          this.$nextTick(function () {
            this.model.ordering_management[typeIdx].delivery_rules[idx].subrules.splice(idxSubrule, 1)
          })
        })
      },
      getDeliveryMethodsDataToSave () {
        this.$nextTick(function () { this.loading = true })
        this.$emit('mapactive', this.model.mapactive)
        var countries = this.$session.get('defaultData').countries

        var locData = this.copyObject(this.model)
        for (var orMngIdx in this.model.ordering_management) {
          // if (
          //   locData.ordering_management[orMngIdx].type === 'eat_location' &&
          //   this.model.ordering_management[orMngIdx].delivery_hour_usage === 2 &&
          //   this.model.ordering_management[orMngIdx].deactivate_delivery_hour_usage
          // ) {
          //   locData.ordering_management[orMngIdx].deactivate_delivery_hour_usage = 0
          //   locData.ordering_management[orMngIdx].delivery_hour_usage = 0
          //   locData.ordering_management[orMngIdx].hour_and_date_delivery_hour_usage = 1
          // }
          if (locData.ordering_management[orMngIdx].type === 'meet_half') {
            for (var idx in locData.ordering_management[orMngIdx].locations) {
              let countryIso = locData.ordering_management[orMngIdx].locations[idx].country
              let countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)
              let states = []
              if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
                states = countries[countryIdx].states
              }
              if (states.length && locData.ordering_management[orMngIdx].locations[idx].state_id) {
                var state = this.getObjectByElemKeyValue('id', locData.ordering_management[orMngIdx].locations[idx].state_id, states)
                if (state !== undefined) {
                  locData.ordering_management[orMngIdx].locations[idx].state = states[state].name
                } else {
                  locData.ordering_management[orMngIdx].locations[idx].state = null
                }
              }
              delete locData.ordering_management[orMngIdx].locations[idx].states
            }
          }
        }

        // copyObject always returns a plain object (not Array), so forEach would throw.
        const sourceRanges = Array.isArray(this.deliveryRanges) ? this.deliveryRanges : []
        const deliveryRanges = JSON.parse(JSON.stringify(sourceRanges))
        deliveryRanges.forEach(range => {
          if (!range) return
          if (this.taxesVersion === 2) {
            delete range.shipping_cost_vat_id
            delete range.shipping_cost_vat_rate_id
            delete range.shipping_cost
            delete range.shipping_pos_id
            delete range.min_order_value
            delete range.extra_delivery_time
            delete range.delivery_range_cost_rules
          } else {
            delete range.shipping_cost_vat_rate_id
          }
        })

        var data = {
          'token': this.$session.get('token'),
          'company_id': this.$session.get('selectedCompany'),
          'delivery_methods': locData.ordering_management,
          'delivery_ranges': deliveryRanges
        }

        return data
      },
      drawing (obj) {},
      changeDeliveryZone (obj) {
        if (obj.action === 'delete') {
          this.deliveryRanges.splice(obj.indexZone, 1)
        }
      },
      duplicateZone (indexZone) {
        const source = this.deliveryRanges[indexZone]
        if (!source) return

        const clone = JSON.parse(JSON.stringify(source))
        delete clone.id
        clone.name = (clone.name || '') + ' (copy)'
        if (Array.isArray(clone.delivery_range_cost_rules)) {
          clone.delivery_range_cost_rules.forEach(rule => {
            if (!rule) return
            delete rule.id
            delete rule.delivery_ranges_id
          })
        }

        this.deliveryRanges.push(clone)
        this.model.mapactive = this.deliveryRanges.length - 1
      },
      addNewZone (locId, type) {
        this.pushEmptyDeliveryZones(locId)
      },
      pushEmptyDeliveryZones (locId) {
        if (!this.deliveryRanges) {
          this.deliveryRanges = []
        }
        let length = this.deliveryRanges.push({
          'name': '',
          'shape': {},
          'shipping_cost_vat_rate_id': null
        })
        this.model.mapactive = (length - 1)
      },
      handleChangeArea (area, locId) {
        this.$nextTick(() => {
          if (area === 'draw') {
            if (!this.deliveryRanges) {
              this.deliveryRanges = []
            }
            if (!this.deliveryRanges.length) {
              this.pushEmptyDeliveryZones(locId)
            }
          }
        })
      },
      addMethodInfo (orderIdx) {
        let newRow = {
          'title': '',
          'type': 'check',
          'options': []
        }

        if (!this.model.ordering_management[orderIdx].hasOwnProperty('method_info') || !this.model.ordering_management[orderIdx].method_info) {
          Vue.set(this.model.ordering_management[orderIdx], 'method_info', [])
        }

        this.model.ordering_management[orderIdx].method_info.push(newRow)

        this.methodInfoIndex = this.model.ordering_management[orderIdx].method_info ? this.model.ordering_management[orderIdx].method_info.length - 1 : 0
      },
      deleteMethodInfo (orderIdx, id) {
        swal({
          text: this.$t('catalogProdOpt.areyouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            this.methodInfoIndex = this.model.ordering_management[orderIdx].method_info.splice(id, 1)
          }
        })
      },
      addMethodInfoOptionValue (orderIdx, optIdx) {
        let newRow = {
          'title': ''
        }
        this.model.ordering_management[orderIdx].method_info[optIdx].options.push(newRow)
      },
      deleteMethodInfoOptionValue (orderIdx, optIdx, idx) {
        this.model.ordering_management[orderIdx].method_info[optIdx].options.splice(idx, 1)
      },
      deleteReservationsIntervalsValue (orderIdx, resIntIdx) {
        this.model.ordering_management[orderIdx].reservations_intervals.splice(resIntIdx, 1)
      },
      addMoreReservationsIntervals (orderIdx) {
        if (!Array.isArray(this.model.ordering_management[orderIdx].reservations_intervals)) {
          this.model.ordering_management[orderIdx].reservations_intervals = []
        }
        // let index = this.model.ordering_management[orderIdx].reservations_intervals.length;

        this.model.ordering_management[orderIdx].reservations_intervals.push('')
      },
      changeDeliveryHourUsage (order) {
        order.hour_and_date_delivery_hour_usage = false
        order.just_date_delivery_hour_usage = false
        order.deactivate_delivery_hour_usage = false
        // order.next_day_delivery_hour_usage = false
        switch (order.delivery_hour_usage) {
          case 0:
            order.hour_and_date_delivery_hour_usage = true
            break
          case 1:
            order.just_date_delivery_hour_usage = true
            break
          default:
            order.deactivate_delivery_hour_usage = true
        }
      },
      addMoreIntervals (dayIdx, orderIdx) {
        let index = 0
        if (!this.model.ordering_management[orderIdx].available_days[dayIdx].hasOwnProperty('intervals')) {
          Vue.set(this.model.ordering_management[orderIdx].available_days[dayIdx], 'intervals', [])
        } else {
          index = this.model.ordering_management[orderIdx].available_days[dayIdx].intervals.length
        }
        const newObj = {
          'open_from': '',
          'open_to': ''
        }
        Vue.set(this.model.ordering_management[orderIdx].available_days[dayIdx].intervals, index, newObj)
      },
      deleteIntervals (intervalKey, dayIdx, orderIdx) {
        this.model.ordering_management[orderIdx].available_days[dayIdx].intervals.splice(intervalKey, 1)
      },
      addReservationTaxesInfo (orderIdx) {
        this.model.ordering_management[orderIdx].reservation_taxes.push({
          'id': 0,
          'name': 'Rezervare',
          'price': 0,
          'is_advance_consumption': false,
          'table_zone_id': 0,
          'date_from': '',
          'date_to': '',
          'deleted_at': null
        })
      },
      deleteReservationTaxesInfo (orderIdx, idTax) {
        swal({
          text: this.$t('catalogProdOpt.areyouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            if (this.model.ordering_management[orderIdx].reservation_taxes[idTax].id) {
              this.model.ordering_management[orderIdx].reservation_taxes[idTax].deleted_at = 1
            } else {
              this.reservationTaxesIndex = this.model.ordering_management[orderIdx].reservation_taxes.splice(idTax, 1)
            }
          }
        })
      },
      isAutoChangeEnabledChange (orderIdx) {
        if (!this.isAutoChangeEnabled[orderIdx]) {
          this.model.ordering_management[orderIdx].status_from_auto_change = null
          this.model.ordering_management[orderIdx].status_to_auto_change = null
          this.model.ordering_management[orderIdx].auto_change_status_after_min = null
        }
      },
      goToCompany () {
        this.$session.set('selectedTab', this.$t('settingsPages.locationGroups'))
        window.location.reload(true)
      }
    }
  }
</script>
<style lang="scss">
  .customItem {
    display: flex;
    justify-content: flex-start;
    flex-direction: column; 
    width: 90%;
  }
  .align {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .closeBtn {
    margin-top: 10px;
    width: 10%;
    display: flex;
  }
  .changeDeliveryDisponibility {
    .radio {
      label::before,
      label::after {
        top: 0;
        line-height: 1;
      }
    }
  }
</style>
<style>
  .el-date-editor.el-input{ max-width: 170px; }
  .padd{ padding: 4px 15px; }
  .company-details .sortableRow .el-collapse-item__header:before {
    content: "\f047";
    width: 21px;
    text-align: center;
    display: inline-block;
    font: normal normal normal 14px/1 FontAwesome;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin-right: 7px;
    cursor: move;
  }
</style>
<style scoped lang="scss">
  .delivery-zone-header {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    gap: 10px;
    padding-right: 10px;
  }

  .delivery-zone-duplicate {
    margin-left: auto;
    flex-shrink: 0;
  }

  .changeDeliveryDisponibility {
    display: flex;
    align-items: center;
    .checkbox {
      margin: 10px;
      margin-left: 0;
    }
  }

  .draw-zones-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .copy-ranges-list {
    max-height: 300px;
    overflow: auto;
    border: 1px solid #eee;
    border-radius: 6px;
    padding: 10px;
    background: #fff;
  }

  .copy-range-item {
    padding: 8px 6px;
    border-bottom: 1px solid #f2f2f2;
  }

  .copy-range-item:last-child {
    border-bottom: 0;
  }

  .copy-delivery-ranges-modal,
  .copy-delivery-ranges-modal .card-content {
    height: 100%;
  }

  .copy-delivery-ranges-modal .card-content {
    display: flex;
    flex-direction: column;
    padding-bottom: 0;
  }

  .copy-delivery-ranges-body {
    flex: 1;
    min-height: 0;
    overflow: auto;
    padding-bottom: 10px;
  }

  .copy-delivery-ranges-footer {
    margin-top: 0;
    padding: 18px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    border-top: 1px solid #e9e9e9;
  }

  .copy-delivery-ranges-footer .btn {
    height: 40px;
    padding: 0 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .copy-delivery-ranges-footer .btn img {
    height: 16px;
    width: 16px;
  }

  .reservations-widget-embed {
    display: flex;
    gap: 24px;
    align-items: stretch;
    margin: 10px 0 28px;
    padding: 18px;
    border: 1px solid #e6e8ef;
    border-radius: 12px;
    background: #fafbff;
  }

  .rw-config {
    flex: 1 1 0;
    min-width: 0;
  }

  .rw-config h6 {
    margin: 0 0 6px;
    font-weight: 600;
    font-size: 16px;
  }

  .rw-hint {
    color: #6b7280;
    font-size: 13px;
    margin-bottom: 14px;
    line-height: 1.4;
  }

  .rw-auto-ids {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 16px;
  }

  .rw-auto-ids > div {
    background: #fff;
    border: 1px solid #e6e8ef;
    border-radius: 8px;
    padding: 6px 10px;
    min-width: 140px;
  }

  .rw-auto-ids span {
    display: block;
    font-size: 11px;
    color: #8a8fa3;
    margin-bottom: 2px;
  }

  .rw-auto-ids code {
    font-size: 12px;
    color: #222;
    word-break: break-all;
  }

  .rw-position-btns {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .rw-pos-choice {
    appearance: none;
    -webkit-appearance: none;
    border: 1px solid #d9dce7;
    background: #fff;
    border-radius: 8px;
    padding: 8px 10px;
    font-size: 13px;
    color: #333;
    cursor: pointer;
  }

  .rw-pos-choice.active {
    border-color: #e85a48;
    background: #e85a48;
    color: #fff;
  }

  .rw-preview-col {
    width: 340px;
    flex: 0 0 340px;
  }

  .rw-preview-col label {
    display: block;
    margin-bottom: 8px;
  }

  .rw-site-preview {
    position: relative;
    height: 210px;
    background: #eef1f6;
    border-radius: 14px;
    overflow: hidden;
    margin-bottom: 14px;
    border: 1px solid #e1e5ee;
  }

  .rw-browser-bar {
    height: 18px;
    background: #dde3ee;
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 0 10px;
  }

  .rw-browser-bar span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #c5ccd8;
  }

  .rw-fab {
    position: absolute;
    display: flex;
    align-items: center;
    gap: 10px;
    background: #e85a48;
    color: #fff;
    border-radius: 999px;
    padding: 8px 10px 8px 8px;
    min-width: 210px;
    box-shadow: 0 8px 18px rgba(232, 90, 72, 0.35);
  }

  .pos-bottom-right .rw-fab { right: 12px; bottom: 12px; }
  .pos-bottom-left .rw-fab { left: 12px; bottom: 12px; }
  .pos-top-right .rw-fab { right: 12px; top: 28px; }
  .pos-top-left .rw-fab { left: 12px; top: 28px; }

  .rw-fab-icon {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .rw-fab-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
    flex: 1;
    color: #fff;
  }

  .rw-fab-text strong {
    font-size: 13px;
    line-height: 1.1;
    white-space: nowrap;
    color: #fff;
  }

  .rw-online {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: rgba(0, 0, 0, 0.22);
    border-radius: 999px;
    font-size: 9px;
    letter-spacing: 0.6px;
    padding: 2px 7px;
  }

  .rw-online-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #fff;
    display: inline-block;
  }

  .rw-fab-arrow {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.22);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .rw-script {
    font-family: Consolas, Monaco, monospace;
    font-size: 11px;
    line-height: 1.45;
    background: #fff;
    resize: vertical;
    margin-bottom: 10px;
  }

  .rw-copy-btn {
    width: 100%;
  }

  @media (max-width: 991px) {
    .reservations-widget-embed {
      flex-direction: column;
    }

    .rw-preview-col {
      width: 100%;
      flex: 1 1 auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Locations/DeliveryMethods.vue